/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'
export const SPEC_VERSION = 'v1'
export interface Activity {
  actor_full_name?: string | null
  created_at?: string
  event_type?: string
  id?: number
  metadata?: {}
  normalized_actor_id?: number | null
  normalized_actor_type?: string | null
}

export interface ActivityMetadataV1DriverVerified {
  current_stop_sequence?: null | number
  external_stop_id?: string
  share_id?: number
  status?:
    | 'pending'
    | 'ready_for_dispatch'
    | 'dispatched'
    | 'at_pickup'
    | 'loading'
    | 'in_transit'
    | 'in_yard'
    | 'at_dropoff'
    | 'unloading'
    | 'delivered'
    | 'invoiced'
    | 'payment_pending'
    | 'pod_rejected'
    | 'completed'
    | 'cancelled'
    | 'tonu'
    | 'claim'
  success?: boolean
}

export interface ActivityMetadataV1ShareableShared {
  shared_via?: ('email' | 'sms')[]
  shared_with_driver_name?: string
}

export interface ActivityMetadataV1ShipmentCheckInTimeUpdated {
  stop?: {
    checked_in_at?: null | string
    id?: number
  }
}

export interface ActivityMetadataV1ShipmentCheckOutTimeUpdated {
  stop?: {
    checked_out_at?: null | string
    id?: number
  }
}

// tslint:disable-next-line:no-empty-interface
export interface ActivityMetadataV1ShipmentCreated {}

export interface ActivityMetadataV1ShipmentImported {
  source?: string
}

export interface ActivityMetadataV1ShipmentStatusUpdated {
  current_stop_sequence?: null | number
  status?:
    | 'pending'
    | 'ready_for_dispatch'
    | 'dispatched'
    | 'at_pickup'
    | 'loading'
    | 'in_transit'
    | 'in_yard'
    | 'at_dropoff'
    | 'unloading'
    | 'delivered'
    | 'invoiced'
    | 'payment_pending'
    | 'pod_rejected'
    | 'completed'
    | 'cancelled'
    | 'tonu'
    | 'claim'
  stop?:
    | null
    | {
        checked_in_at?: string
        /**
         * The ID of the stop whose check-in/check-out time was updated in association with the status change. NB: This may be a different stop than the one identified by the status change's `current_stop_sequence`.
         */
        id?: number
      }
    | {
        checked_out_at?: string
        /**
         * The ID of the stop whose check-in/check-out time was updated in association with the status change. NB: This may be a different stop than the one identified by the status change's `current_stop_sequence`.
         */
        id?: number
      }
}

export interface ActivityMetadataV2ShipmentImported {
  current_stop_sequence?: null | number
  source?: string
  status?:
    | 'pending'
    | 'ready_for_dispatch'
    | 'dispatched'
    | 'at_pickup'
    | 'loading'
    | 'in_transit'
    | 'in_yard'
    | 'at_dropoff'
    | 'unloading'
    | 'delivered'
    | 'invoiced'
    | 'payment_pending'
    | 'pod_rejected'
    | 'completed'
    | 'cancelled'
    | 'tonu'
    | 'claim'
}

export interface ActivityMetadataV2ShipmentStatusUpdated {
  current_stop_sequence?: null | number
  status?:
    | 'pending'
    | 'ready_for_dispatch'
    | 'dispatched'
    | 'at_pickup'
    | 'loading'
    | 'in_transit'
    | 'in_yard'
    | 'at_dropoff'
    | 'unloading'
    | 'delivered'
    | 'invoiced'
    | 'payment_pending'
    | 'pod_rejected'
    | 'completed'
    | 'cancelled'
    | 'tonu'
    | 'claim'
  stop?:
    | null
    | {
        checked_in_at?: string
        /**
         * The ID of the stop whose check-in/check-out time was updated in association with the status change. NB: This may be a different stop than the one identified by the status change's `current_stop_sequence`.
         */
        id?: number
      }
    | {
        checked_out_at?: string
        /**
         * The ID of the stop whose check-in/check-out time was updated in association with the status change. NB: This may be a different stop than the one identified by the status change's `current_stop_sequence`.
         */
        id?: number
      }
  /**
   * Subscribers who were sent an email update for this status change.
   */
  subscribers?: {
    email?: string
    id?: number
    name?: null | string
  }[]
}

export interface ActivityMetadataV3ShipmentStatusUpdated {
  current_stop_sequence?: null | number
  status?:
    | 'pending'
    | 'ready_for_dispatch'
    | 'dispatched'
    | 'at_pickup'
    | 'loading'
    | 'in_transit'
    | 'in_yard'
    | 'at_dropoff'
    | 'unloading'
    | 'delivered'
    | 'invoiced'
    | 'payment_pending'
    | 'pod_rejected'
    | 'completed'
    | 'cancelled'
    | 'tonu'
    | 'claim'
  stop?:
    | null
    | {
        checked_in_at?: string
        /**
         * The ID of the stop whose check-in/check-out time was updated in association with the status change. NB: This may be a different stop than the one identified by the status change's `current_stop_sequence`.
         */
        id?: number
      }
    | {
        checked_out_at?: string
        /**
         * The ID of the stop whose check-in/check-out time was updated in association with the status change. NB: This may be a different stop than the one identified by the status change's `current_stop_sequence`.
         */
        id?: number
      }
  /**
   * Subscribers who were sent an email update for this status change.
   */
  subscribers?: {
    email?: string
    id?: number
    name?: null | string
  }[]
  triggered_by_geofence?: boolean
}

export interface ActivityMetadataV4ShipmentStatusUpdated {
  current_stop_sequence?: null | number
  status?:
    | 'pending'
    | 'ready_for_dispatch'
    | 'dispatched'
    | 'at_pickup'
    | 'loading'
    | 'in_transit'
    | 'in_yard'
    | 'at_dropoff'
    | 'unloading'
    | 'delivered'
    | 'invoiced'
    | 'payment_pending'
    | 'pod_rejected'
    | 'completed'
    | 'cancelled'
    | 'tonu'
    | 'claim'
  stop?:
    | null
    | {
        checked_in_at?: string
        /**
         * The ID of the stop whose check-in/check-out time was updated in association with the status change. NB: This may be a different stop than the one identified by the status change's `current_stop_sequence`.
         */
        id?: number
      }
    | {
        checked_out_at?: string
        /**
         * The ID of the stop whose check-in/check-out time was updated in association with the status change. NB: This may be a different stop than the one identified by the status change's `current_stop_sequence`.
         */
        id?: number
      }
  /**
   * Subscribers who were sent an email update for this status change.
   */
  subscribers?: {
    email?: string
    id?: number
    name?: null | string
  }[]
  triggered_by_fms_mobile?: boolean
}

export interface Address {
  addressLine1?: string | null
  addressLine2?: string | null
  addressableId?: number
  addressableType?: string
  addressee?: string | null
  countryCode?: string | null
  id?: number
  locality?: string | null
  postalCode?: string | null
  purpose: 'facility_primary' | 'stop_location'
  sourceAddressId?: number | null
  subdivisionCode?: string | null
}

export interface Attachment {
  /**
   * When set to `true` in a request alongside an existing `blob_id`, causes the attachment to be destroyed.
   */
  _destroy?: boolean
  blob_id?: number
  created_at?: string
  /**
   * Base 64-encoded file contents, used when creating a new attachment.
   */
  file?: string
  /**
   * Used only when creating a new attachment.
   */
  file_file_name?: string
  /**
   * The type of file being uploaded.
   */
  file_type?: 'pod' | 'private' | 'scale_ticket' | 'misc' | 'rate_con' | 'payable'
  filename?: string
  id?: number
  url?: string
}

export interface AttachmentDestroy {
  _destroy?: boolean
  id?: number
}

export interface AuctionShipment {
  bids: ShipmentBid[]
  id: number
  shipmentInfo: AuctionShipmentInfo
  tags: Tag[]
  targetRate: string
}

export interface AuctionShipmentEquipment {
  icon: string
  name: string
  parentId: number
}

export interface AuctionShipmentInfo {
  createdAt: string
  deliveries: AuctionShipmentPickupOrDelivery[]
  equipment: AuctionShipmentEquipment
  info: AuctionShipmentLoadInfo
  opsRep: AuctionShipmentOpsRep
  pickups: AuctionShipmentPickupOrDelivery[]
}

export interface AuctionShipmentLoadInfo {
  commodity: string
  dropTrailer?: boolean
  palletCount: number
  totalMiles: string
  weight: number
}

export interface AuctionShipmentOpsRep {
  email: string
  name: string
  phone: string
}

export interface AuctionShipmentPickupOrDelivery {
  appointmentType: string
  city: string
  departedAt?: string
  endAt?: string | null
  endAtDate?: string | null
  endAtTime?: string | null
  startAt: string
  startAtDate: string
  startAtTime: string
  stateCode: string
  stopSequence: number
  stopType: AuctionStopType
  timezone: string
  zipcode: string
}

export type AuctionStopType = 'pickup' | 'delivery'

export interface BidResponse {
  acceptedBidExpiredAt: string | null
  amount: string
  carrier: {
    motorCarrierId: number
    name: string | null
  } | null
  counterBidAmount?: string | null
  createdAt: string
  createdBy: {
    name: string
    parentUserId: number
  }
  id: number
  shipment: {
    deliveryCity: string | null
    deliveryDate: string | null
    deliveryStateCode: string | null
    equipmentName: 'Dry Van' | 'Open Deck' | 'Reefer' | null
    equipmentType?: string | null
    id: number
    pickupCity: string | null
    pickupDate: string | null
    pickupStateCode: string | null
    state:
      | 'at_dropoff'
      | 'at_pickup'
      | 'cancelled'
      | 'completed'
      | 'delivered'
      | 'dispatched'
      | 'in_transit'
      | 'payment_pending'
      | 'pending'
      | 'pod_rejected'
      | 'ready_for_dispatch'
      | 'tonu'
      | null
    stops?: MarketplaceStopRequest[]
    totalMiles?: Float
    weight: number | null
  } | null
  status: 'pending' | 'accepted' | 'declined' | 'countered'
  targetAmount: string
}

export interface Blob {
  content_type?: string
  file?: string
  filename?: string
  signed_id?: string
}

export interface BlobAttach {
  signed_id?: string
}

export interface BodyId {
  id: number
}

export interface BookableShipmentSavedSearch {
  createdAt?: string
  deliveryCity?: string | null
  /**
   * Only used in conjunction with `deliveryStartDate`. Delivery must occur on or before this date.
   */
  deliveryEndDate?: string | null
  /**
   * Delivery should be within this radius of the provided delivery city/state.
   */
  deliveryMiles?: number | null
  /**
   * If no `deliveryEndDate` is given, the delivery must occur on (not after) this date.
   */
  deliveryStartDate?: string | null
  /**
   * Required if `delivery_city` is present.
   */
  deliveryStateCode?: string | null
  /**
   * BE will default to false if `null` is provided.
   */
  dropTrailer?: boolean | null
  hasNotificationsEnabled?: boolean
  id?: number
  /**
   * Used in conjunction with `loadedMilesMin`. Total loaded distance must be in this range, if provided.
   */
  loadedMilesMax?: number | null
  /**
   * Used in conjunction with `loadedMilesMax`. Total loaded distance must be in this range, if provided.
   */
  loadedMilesMin?: number | null
  motorCarrier?: {
    dotNumber?: number
    id: number
    legalName?: string
    mcNumber?: number
  }
  pickupCity?: string | null
  /**
   * Only used in conjunction with `pickupStartDate`. Pickup must occur on or before this date.
   */
  pickupEndDate?: string | null
  /**
   * Array of integers representing ISO-8601 days of week (i.e., Monday = 1 thru Sunday = 7). Pickup must be on one of these days of the week. Used when there is no specific `pickup{Start,End}Date`.
   */
  pickupIsoDaysOfWeek?: number[] | null
  /**
   * Pickup should be within this radius of the provided pickup city/state.
   */
  pickupMiles?: number | null
  /**
   * If no `pickupEndDate` is given, the pickup must occur on (not after) this date.
   */
  pickupStartDate?: string | null
  /**
   * Required if `pickup_city` is present.
   */
  pickupStateCode?: string | null
  pickupTimes?: string[] | null
  rate?: number | null
  rateType?: '' | 'all_in' | 'rpm' | null
  /**
   * The creation source for this saved search.
   */
  sourceType?:
    | 'dispatcher_created'
    | 'cm_created'
    | 'auto_historical'
    | 'dispatcher_truck_availability'
    | null
  /**
   * The total number of matching search results.
   */
  totalResultCount?: number
  /**
   * Corresponds to the Marketplace "equipment key" (`equipment.key` in the MP DB.)
   */
  trailerType?: string | null
  /**
   * The number of search results that the user has not yet viewed.
   */
  unviewedResultCount?: number
  updatedAt?: string
}

export interface Comment {
  attachments: Attachment[]
  author: {
    full_name?: string
  }
  comment_text: string
  created_at: string
  id?: number
  updated_at: string
}

export interface CommentCreate {
  blobs?: BlobAttach[]
  comment_text: string
  id?: number
}

export interface CommentUpdate {
  attachments?: AttachmentDestroy[]
  blobs?: BlobAttach[]
  comment_text: string
  id?: number
}

export interface Contact {
  contactable_id?: number
  contactable_type?: string
  email?: string | null
  id?: number
  name: string
  phone?: string | null
  phone_ext?: string | null
  purpose:
    | 'customer_additional'
    | 'customer_primary'
    | 'facility_additional'
    | 'facility_primary'
    | 'shipment_customer'
    | 'shipment_subscriber'
    | 'shipment_ops_representative'
    | 'stop_facility'
  source_contact_id?: number | null
}

export interface ContactFilters {
  /**
   * Partial contact name or email
   */
  search?: string
}

export interface Customer {
  contacts?: Contact[]
  id?: number
  imported_from_quickbooks?: boolean
  name: string
  notes?: string | null
}

export interface CustomerFilters {
  name?: string
}

export interface CustomerWithoutAssociations {
  id?: number
  name: string
  notes?: string | null
}

export interface DedicatedLane {
  capacityPerWeek?: string
  carrier?: {
    email?: string
    name?: string
  }
  deliveryCity?: string
  deliveryRadiusMiles?: number
  deliveryState?: string
  equipment?: string
  expirationDate?: string
  id?: number
  isOnlyBeer?: boolean
  isOnlyDropTrailer?: boolean
  pickupCity?: string
  pickupRadiusMiles?: number
  pickupState?: string
  rate?: string
  rateType?: 'rpm' | 'flat'
  shipper?: {
    name?: string
  }
  smsNotificationsEnabled?: boolean
  startDate?: string
}

export interface DedicatedLanesBid {
  /**
   * Bid (request_for_proposal_lane_carrier_rate) ID
   */
  bidId?: number
  /**
   * Whether the bid includes weekend shipments
   */
  canDoWeekends?: boolean
  /**
   * Carrier Application ID for the carrier fulfilling the bid
   */
  carrierApplicationId?: number
  /**
   * Carrier Legal Name
   */
  carrierApplicationLegalName?: string
  /**
   * Email address of the contact placing the bid
   */
  contactEmail?: string | null
  /**
   * Message from the contact placing the bid
   */
  contactMessage?: string | null
  /**
   * Phone number of the contact placing the bid
   */
  contactPhone?: string | null
  /**
   * Carrier dot_number
   */
  dotNumber?: number
  /**
   * Carrier mc_number
   */
  mcNumber?: number | null
  /**
   * Proposed rate per load
   */
  rateAmount?: number
  /**
   * Proposed rate type
   */
  rateType?:
    | 'rfp_lane_carrier_line_haul_rpm'
    | 'rfp_lane_carrier_all_in'
    | 'rfp_lane_carrier_line_haul_flat'
  /**
   * Dedicated lane (shipper_rate) id that's being bid on
   */
  shipperRateId?: number
  /**
   * Proposed weekly load volume
   */
  weeklyLoadVolume?: number
}

export interface DedicatedLanesBidInquire {
  /**
   * Email address of the contact placing the bid
   */
  contact_email?: string
  /**
   * Message from the contact placing the bid
   */
  contact_message?: string
  /**
   * Phone number of the contact placing the bid
   */
  contact_phone?: string
}

export interface Dispatcher {
  fullName?: string | null
  /**
   * Transfix parent user ID
   */
  id?: number | null
  motorCarriers?: MotorCarrier[]
}

export interface Driver {
  cellPhone?: string | null
  /**
   * False if the driver has unsubcribed from receiving SMS messages from us.
   */
  cellPhoneIsTwilioSubscribed?: boolean
  email?: string | null
  firstName?: string
  id?: number
  lastName?: string
  motorCarrierId?: number
  motorCarrierLegalName?: string
  motorCarriers?: MotorCarrier[]
  name: string
  phone?: string | null
  settings?: {
    /**
     * Is the driver opted-in to receive SMS requests for load status updates?
     */
    sms_status_updates_enabled?: boolean
    /**
     * Suppresses the opt-in modal for SMS status updates.
     */
    suppress_sms_status_updates_opt_in?: boolean
  }
  status?: 'active' | 'inactive'
  /**
   * Parent User ID of the Driver
   */
  transfixUserId?: number | null
  updatedAt?: string
}

export interface EquipmentFilters {
  /**
   * Partial trailer number
   */
  trailer_number?: string
  /**
   * Partial truck number
   */
  truck_number?: string
}

export interface Facility {
  addresses?: Address[]
  contacts?: Contact[]
  id?: number
  name: string
  updated_at?: string
}

export interface FacilityFilters {
  /**
   * Partial facility name, address, or contact
   */
  name_address_or_contact?: string
  /**
   * Partial facility name or locality (city)
   */
  name_or_locality?: string
}

export interface FacilityWithoutAssociations {
  id?: number
  name: string
  updated_at?: string
}

/**
 * Float serialized as a string.
 */
export type Float = string

export interface GuidedBidsMeetsThresholdResponse {
  result?: string
}

export interface KeepTruckinAuthCode {
  code?: string
  motorCarrierId?: string
  state?: string
}

export interface KeepTruckinDriver {
  driverCompanyId?: number | null
  email?: string
  firstName?: string
  id?: number
  lastName?: string
  role?: string
  status?: string
  username?: string | null
}

export interface KeepTruckinLocation {
  bearing?: number
  description?: string
  engineHours?: number
  fuel?: number
  id?: string
  lat?: number
  locatedAt?: string
  lon?: number
  odometer?: number
  speed?: number
  type?: string
}

export interface KeepTruckinTruckLocations {
  currentDriver?: KeepTruckinDriver | null
  currentLocation?: KeepTruckinLocation | null
  id?: number
  make?: string | null
  model?: string | null
  number?: string | null
  vin?: string | null
  year?: string | null
}

export type LoadRecommendation = BookableShipmentSavedSearch & {
  recommendations?: Recommendation[]
  recommendationsCount?: number
  recommendationsUnviewedCount?: number
}

export interface MarketplaceStopRequest {
  address?: Address
  appointment_number?: string | null
  bol_number?: string | null
  commodity?: string | null
  /**
   * IANA time zone name.
   */
  display_timezone?: string
  /**
   * The UTC date/time at which the stop window ends.
   */
  end_at?: string | null
  /**
   * The ID of the stop in the external system.
   */
  external_id?: string
  /**
   * The UTC timestamp at which the stop was last updated in the external system.
   */
  external_updated_at?: string
  instructions_from_customer?: string | null
  is_drop_trailer?: boolean
  po_number?: string | null
  /**
   * The stop's UTC date/time (or, if applicable, the beginning of the stop window).
   */
  start_at?: string
  stop_type?: StopType
  unit?: string | null
  unit_quantity?: number | null
  weight?: number | null
}

export interface MotorCarrier {
  dbaName?: string | null
  dotNumber?: number | null
  id?: number
  isKeepTruckinEnabled?: boolean
  /**
   * Full name of the user who connected the carrier with keep truckin. Null if not connected
   */
  keepTruckinConnector?: string | null
  legalName?: string
  mcNumber?: number | null
  name: string
}

export interface MotorCarrierForUser {
  /**
   * Information about this carrier in Marketplace. `null` if the carrier does not exist in Marketplace or if the user is not a member of the carrier.
   */
  carrier_application?: {
    has_added_references?: boolean
    has_signed_bca?: boolean
    has_uploaded_documents?: boolean
    id?: number
    is_project44_enabled?: boolean
    status?:
      | 'new'
      | 'pending'
      | 'application_submitted'
      | 'in_review'
      | 'activated'
      | 'out_of_service'
      | 'conditional'
      | 'cancelled'
      | 'other'
      | 'probation'
      | 'do_not_use'
      | 'expired_insurance'
  } | null
  /**
   * Information about the user's relationship to the carrier. `null` if the user is not currently a member of the carrier.
   */
  membership?: {
    /**
     * Timestamp representing when the user joined the carrier.
     */
    created_at?: string
    role?: 'admin' | 'employee'
    user_type?: 'dispatcher' | 'driver' | 'owner_operator'
    users_count?: number
  } | null
  motor_carrier?: MotorCarrier
  /**
   * Information about the user's peniding request to join the carrier. `null` if the user is currently a member of the carrier.
   */
  requested_membership?: {
    /**
     * Timestamp representing when the user requested to join the carrier.
     */
    created_at?: string
  } | null
}

export interface MotorCarrierJoinRequest {
  /**
   * The time that this join request was approved
   */
  approved_at?: string | null
  approved_by?: {
    email?: string
    full_name?: string
  } | null
  id: number
  motor_carrier: MotorCarrier
  requested_by: {
    email?: string
    full_name?: string
  }
}

export interface MotorCarriers {
  dbaName?: string
  dotNumber?: number
  id?: number
  isTruckingEnabled?: boolean
  keepTruckingConnector?: string
  legalName?: string
  mcNumber?: number
  name?: string
}

export interface OfferedShipment {
  acceptedBidExpiredAt?: number
  carrierName?: string
  carrierRate?: number
  carrierTotalRate?: number
  deliveryCity?: string
  deliveryState?: string
  externalId?: number
  offeredRate?: number
  /**
   * The state of this offered shipment -- the UI will use this for display, as well as an indication of when to use the reoffer API
   */
  offeredState?:
    | 'transfix_offer'
    | 'bid_accepted'
    | 'dedicated_rate_current_tier_carrier'
    | 'dedicated_rate_offered_to_more_carriers'
  pickupCity?: string
  pickupState?: string
  state?: string
  stops?: OfferedShipmentStop[]
  waterfallTimeLeftMinutes?: number
}

export interface OfferedShipmentStop {
  address?: Address
  appointmentNumber?: string | null
  bolNumber?: string | null
  /**
   * The UTC timestamp at which the load arrived at this stop.
   */
  checkedInAtt?: string | null
  /**
   * The UTC timestamp at which the load departed from this stop.
   */
  checkedOutAtt?: string | null
  commodity?: string | null
  /**
   * Timezone inferred from the stop's location, for use in conversions from UTC timestamps.
   */
  displayTimezone?: string
  /**
   * The UTC timestamp at which the stop window ends.
   */
  endAt?: string | null
  /**
   * The ID of the stop in the shipment's external system.
   */
  externalId?: string | null
  externalUpdatedAt?: string | null
  /**
   * Instructions _provided by_ the stop's customer. Not intended to be modified by a dispatcher.
   */
  instructionsFromCustomer?: string | null
  isDropTrailer?: boolean
  poNumber?: string | null
  /**
   * The UTC timestamp of the stop (or, if applicable, the beginning of the stop window).
   */
  startAt?: string
  stop_type?: StopType
  unit?: string | null
  unitQuantity?: number | null
  weight?: number | null
}

export interface QuickbooksAuthCode {
  code?: string
  realm_id?: string
  state?: string
}

export interface Recommendation {
  createdAt?: string
  deliveryCity?: string
  deliveryStateCode?: string
  deliveryTimes?: string[]
  deliveryTimezone?: string
  distance?: number
  dropTrailer?: boolean
  equipmentKey?: string
  equipmentName?: string
  equipmentParentId?: number
  opsRepEmail?: string
  opsRepName?: string
  pickupCity?: string
  pickupStateCode?: string
  pickupTimes?: string[]
  pickupTimezone?: string
  rate?: string
  shipmentId?: number
  stops?: {
    appointmentType?: string
    city?: string | null
    dropTrailer?: boolean
    /**
     * The UTC timestamp of the stop (or, if applicable, the beginning of the stop window).
     */
    endAt?: string
    endAtDate?: string | null
    endAtTime?: string | null
    latitude?: number
    longitude?: number
    /**
     * The UTC timestamp of the stop (or, if applicable, the beginning of the stop window).
     */
    startAt?: string
    startAtDate?: string | null
    startAtTime?: string | null
    stateCode?: string | null
    stopSequence?: number
    stopType?: AuctionStopType
    timezone?: string | null
    zipcode?: string | null
  }[]
  unviewed?: boolean
  weight?: number
}

export interface SetupGuide {
  dismissed?: boolean
  setup_guide?: SetupGuideSteps[]
}

export interface SetupGuideSteps {
  status?: string
  type?: string
}

export interface Share {
  id?: number
  /**
   * The UTC timestamp at which the share was last shared with the recipient.
   */
  lastSharedAt?: string | null
  /**
   * The method(s) by which the share was last shared with the recipient.
   */
  lastSharedVia?: ShareMethod[] | null
  shareableId?: number
  shareableType?: string
  sharedWithDriver?: Driver
  sharedWithDriverId?: number
  url?: string
}

export type ShareMethod = 'email' | 'sms'

export interface ShareSend {
  message?: string
  share_via?: ShareMethod[]
}

export interface Shipment {
  attachments?: Attachment[]
  createdAt?: string
  currentStopSequence?: number | null
  customer?: null | Customer
  customerContact?: null | Contact
  /**
   * Internal notes _about_ this shipment's customer. Intended to be populated/modified by a dispatcher and not visible to the customer.
   */
  customerNotes?: string | null
  dispatcher?: Dispatcher
  drivers?: Driver[]
  /**
   * The displayed identifier for the shipment, editable by users. NOT an external system's identifier for the shipment.
   */
  externalId?: string | null
  /**
   * For a shipment that `is_external`, this value is UTC timestamp at which the shipment was last updated in the external system.
   */
  externalUpdatedAt?: string | null
  id?: number
  /**
   * Instructions _provided by_ the shipment's customer. Not intended to be modified by a dispatcher.
   */
  instructionsFromCustomer?: string | null
  /**
   * Indicates whether the shipment was created from an external source, like the Transfix Marketplace.
   */
  isExternal?: boolean
  isSample?: boolean
  miles?: Float
  mostRecentActivity?: null | Activity
  motorCarrier?: MotorCarrier
  /**
   * A dispatcher's _internal_ notes or instructions about this shipment.
   */
  notes?: string | null
  pods?: Attachment[]
  rate?: null | Float
  securingOptions?: string | null
  status?: ShipmentStatus
  stops?: Stop[]
  subscribers?: Contact[]
  temperatureSetting?: TemperatureSetting
  trackingMethod?:
    | 'mobile'
    | 'project_44'
    | 'keep_truckin'
    | 'fms_mobile'
    | 'one_time_location'
    | ''
    | null
  trailer?: null | Trailer
  trailerLength?: string | null
  trailerType?: string | null
  truck?: null | Truck
  updatedAt?: string
}

export interface ShipmentBid {
  acceptedAt?: string | null
  amount?: string
  carrierApplicationId?: number
  carrierDotNumber?: string
  carrierMcNumber?: string
  carrierName?: string
  created_by_name?: string | null
  created_by_parent_user_id?: number
  declinedAt?: string | null
  id?: number
  status: 'pending' | 'accepted' | 'declined'
  updatedAt?: string
}

export interface ShipmentDetentionRequest {
  shipment: {
    accessorials: {
      additionalInfo: {
        endDateTime: string
        externalNote?: string
        startDateTime: string
        submittedBy?: string
      }
      amount: string
      endAt: string
      endDateTime: string
      endDateTimeIsValid: boolean
      file: string
      fileFileName?: string
      fileName: string
      name: string
      shipperFacilityUuid: string
      startAt: string
      startDateTime: string
      startDateTimeIsValid: boolean
      title: string
    }[]
  }
}

export interface ShipmentFilters {
  customer_id?: number
  dispatcher_id?: number
  /**
   * Numeric ID of the driver, or 'unassigned' to retrieve shipments with no drivers.
   */
  driver_id?: string
  dropoff_date?: string
  dropoff_facility_id?: number
  dropoff_locality?: string
  dropoff_subdivision_code?: string
  pickup_date?: string
  pickup_facility_id?: number
  pickup_locality?: string
  pickup_subdivision_code?: string
  /**
   * Filters on shipment external ID and stop appointment, PO, BOL, or reference number.
   */
  reference_number?: string
  status?: ShipmentStatus[]
}

export interface ShipmentLocations {
  eta?: {
    distance?: number
    eta?: string
    on_time?: boolean
  } | null
  /**
   * Is the most recent location for the current shipment, or another (earlier) shipment for this truck/driver?
   */
  last_location_is_for_current_shipment?: boolean | null
  recent_locations?: {
    latitude?: number
    located_at?: string
    location_source?: 'mobile' | 'project_44' | 'keep_truckin' | 'fms_mobile' | 'one_time_location'
    longitude?: number
  }[]
}

export interface ShipmentRequest {
  all_attachments?: Attachment[]
  current_stop_sequence?: number | null
  customer?: {
    id?: number
  }
  customer_contact?: {
    id?: number
  }
  /**
   * Internal notes _about_ this shipment's customer. Intended to be populated/modified by a dispatcher and not visible to the customer.
   */
  customer_notes?: string | null
  dispatcher_id?: number
  drivers?: {
    _destroy?: boolean
    id?: number
  }[]
  /**
   * The displayed identifier for the shipment, editable by users. NOT an external system's identifier for the shipment.
   */
  external_id?: string | null
  miles?: Float
  motor_carrier_id?: number
  /**
   * A dispatcher's _internal_ notes or instructions about this shipment.
   */
  notes?: string | null
  rate?: Float
  status?: ShipmentStatus
  stops?: StopRequest[]
  temperature_setting?: TemperatureSetting
  trailer_id?: number | null
  trailer_length?: string | null
  trailer_type?: string | null
  truck_id?: number | null
}

export type ShipmentStatus =
  | 'pending'
  | 'ready_for_dispatch'
  | 'dispatched'
  | 'at_pickup'
  | 'loading'
  | 'in_transit'
  | 'in_yard'
  | 'at_dropoff'
  | 'unloading'
  | 'delivered'
  | 'invoiced'
  | 'payment_pending'
  | 'pod_rejected'
  | 'completed'
  | 'cancelled'
  | 'tonu'
  | 'claim'

export interface Stop {
  address?: Address
  appointmentNumber?: string | null
  bolNumber?: string | null
  /**
   * The UTC timestamp at which the load arrived at this stop.
   */
  checkedInAt?: string | null
  /**
   * The UTC timestamp at which the load departed from this stop.
   */
  checkedOutAt?: string | null
  commodity?: string | null
  createdAt?: string
  /**
   * Timezone inferred from the stop's location, for use in conversions from UTC timestamps.
   */
  displayTimezone?: string
  /**
   * The datetime the trailer arrived at the stop facility
   */
  dropTrailerArrivedAt?: string | null
  /**
   * The datetime the drop_trailer_arrived_at field was updated
   */
  dropTrailerArrivedUpdatedAt?: string | null
  /**
   * The user id who last updated the drop_trailer_arrived_at field
   */
  dropTrailerArrivedUpdatedById?: number | null
  /**
   * The datetime the trailer was empty
   */
  dropTrailerEmptyAt?: string | null
  /**
   * The datetime the drop_trailer_empty_at field was updated
   */
  dropTrailerEmptyUpdatedAt?: string | null
  /**
   * The user id who last updated the drop_trailer_empty_at field
   */
  dropTrailerEmptyUpdatedById?: number | null
  /**
   * The UTC timestamp at which the stop window ends.
   */
  endAt?: string | null
  /**
   * The ID of the stop in the shipment's external system.
   */
  externalId?: string | null
  facility?: FacilityWithoutAssociations
  facilityContact?: Contact
  id?: number
  /**
   * A dispatcher's _internal_ notes or instructions about this stop.
   */
  instructions?: string | null
  /**
   * Instructions _provided by_ the stop's customer. Not intended to be modified by a dispatcher.
   */
  instructionsFromCustomer?: string | null
  isDropTrailer?: boolean
  poNumber?: string | null
  /**
   * This reference number is the "pickup number" or the "delivery number".
   */
  referenceNumber?: string | null
  /**
   * The stop's sequence number, relative to the stop type, 1-indexed.
   */
  relativeStopSequence?: number
  /**
   * The UTC timestamp of the stop (or, if applicable, the beginning of the stop window).
   */
  startAt?: string
  /**
   * The stop's absolute sequence number, irrespective of the stop type, 1-indexed.
   */
  stopSequence?: number
  stopType?: StopType
  unit?: string | null
  unitQuantity?: number | null
  updatedAt?: string
  weight?: number | null
}

export interface StopRequest {
  address?:
    | {
        id?: number
      }
    | Address
  appointment_number?: string | null
  bol_number?: string | null
  /**
   * The date/time at which the load arrived at this stop. Assumed to be in the local timezone of the stop's location.
   */
  checked_in_at?: string | null
  /**
   * The date/time at which the load departed from this stop. Assumed to be in the local timezone of the stop's location.
   */
  checked_out_at?: string | null
  commodity?: string | null
  /**
   * The datetime the trailer arrived at the stop facility
   */
  drop_trailer_arrived_at?: string | null
  /**
   * The datetime the trailer was empty
   */
  drop_trailer_empty_at?: string | null
  /**
   * The date/time at which the stop window ends. Assumed to be in the local timezone of the stop's location.
   */
  end_at?: string | null
  facility?:
    | {
        id?: number
      }
    | FacilityWithoutAssociations
  facility_contact?: null | {
    id?: number
  }
  id?: number
  /**
   * A dispatcher's _internal_ notes or instructions about this stop.
   */
  instructions?: string | null
  is_drop_trailer?: boolean
  po_number?: string | null
  /**
   * This reference number is the "pickup number" or the "delivery number".
   */
  reference_number?: string | null
  /**
   * The stop's date/time (or, if applicable, the beginning of the stop window). Assumed to be in the local timezone of the stop's location.
   */
  start_at?: string
  stop_sequence?: number
  stop_type?: StopType
  unit?: string | null
  unit_quantity?: number | null
  weight?: number | null
}

export type StopType = 'pickup' | 'dropoff'

export interface Tag {
  taggableId: number
  taggableType: string
  variant: string
}

export interface TeamMember {
  cell_phone?: number | null
  email?: number | null
  first_name?: number
  id?: number
  last_name?: number
  motor_carrier_details?: {
    dot_number?: number
    legal_name?: string
    motor_carrier_id?: number
    motor_carrier_number?: number
    role?: number
    user_type?: number
  }[]
  phone?: number | null
}

export interface TemperatureSetting {
  fixed_temperature?: null | Float
  id?: number
  max_temperature?: null | Float
  min_temperature?: null | Float
  precool?: null | Float
  temperature_type?: TemperatureType
}

export type TemperatureType = 'fixed' | 'continuous'

export type TimestampWithTimezone = string

export interface Todo {
  marketplace_id?: number
  missing_driver?: boolean
  missing_truck_number?: boolean
  missing_vin?: boolean
  pod_missing?: boolean
  pod_rejected?: boolean
  shipment_id?: number
  stops?: Stop[]
}

export interface Trailer {
  id?: number | null
  motorCarrierId?: number
  trailerLength?: string | null
  trailerNumber?: string
  trailerType?: string | null
}

export interface Truck {
  id?: number | null
  keepTruckinId?: number | null
  motorCarrierId?: number
  truckNumber?: string
  vin?: string | null
}

export interface User {
  cell_phone?: string | null
  first_name?: string | null
  full_name?: string | null
  has_carrier_scorecard_enabled?: boolean
  has_quickbooks_enabled?: boolean
  id?: number
  last_name?: string | null
  onboarding?: UserOnboarding
  phone?: string | null
  settings?: UserSettings
}

export interface UserOnboarding {
  marketplace_load_sync_viewed?: boolean
  setup_guide_dismissed?: boolean
  truck_availability_dismissed?: boolean
}

export interface UserSettings {
  default_fleet_view_days?: number
  signup_intent?: string[]
  time_format?: string
}

export interface GetAddressResponse {
  address?: Address
}

export interface GetAddressPathParams {
  id: number
}

export type GetAddressProps = Omit<
  GetProps<GetAddressResponse, unknown, void, GetAddressPathParams>,
  'path'
> &
  GetAddressPathParams

/**
 * Retrieves an address
 */
export const GetAddress = ({ id, ...props }: GetAddressProps) => (
  <Get<GetAddressResponse, unknown, void, GetAddressPathParams>
    path={`/addresses/${id}`}
    {...props}
  />
)

export type UseGetAddressProps = Omit<
  UseGetProps<GetAddressResponse, unknown, void, GetAddressPathParams>,
  'path'
> &
  GetAddressPathParams

/**
 * Retrieves an address
 */
export const useGetAddress = ({ id, ...props }: UseGetAddressProps) =>
  useGet<GetAddressResponse, unknown, void, GetAddressPathParams>(
    (paramsInPath: GetAddressPathParams) => `/addresses/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export type DeleteAttachmentProps = Omit<
  MutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Deletes an existing attachment for a resource
 */
export const DeleteAttachment = (props: DeleteAttachmentProps) => (
  <Mutate<void, unknown, void, number, void> verb='DELETE' path={`/attachments`} {...props} />
)

export type UseDeleteAttachmentProps = Omit<
  UseMutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Deletes an existing attachment for a resource
 */
export const useDeleteAttachment = (props: UseDeleteAttachmentProps) =>
  useMutate<void, unknown, void, number, void>('DELETE', `/attachments`, { ...props })

export interface BookableShipmentRecommendationsResponse {
  bookableShipmentSavedSearchRecommendations?: LoadRecommendation[]
  hasNextPage: boolean
  totalCount: number
}

export interface BookableShipmentRecommendationsQueryParams {
  /**
   * Which page of results to return
   */
  pageNumber?: number
  /**
   * How many results to return per page
   */
  pageSize?: number
  /**
   * An optional array of source types to filter by
   */
  sourceTypes?: (
    | 'dispatcher_created'
    | 'cm_created'
    | 'auto_historical'
    | 'dispatcher_truck_availability'
  )[]
  /**
   * An optional limit on the number of recommendations to return per lane
   */
  limit?: number
}

export type BookableShipmentRecommendationsProps = Omit<
  GetProps<
    BookableShipmentRecommendationsResponse,
    unknown,
    BookableShipmentRecommendationsQueryParams,
    void
  >,
  'path'
>

/**
 * Get load recommendations for user
 */
export const BookableShipmentRecommendations = (props: BookableShipmentRecommendationsProps) => (
  <Get<
    BookableShipmentRecommendationsResponse,
    unknown,
    BookableShipmentRecommendationsQueryParams,
    void
  >
    path={`/bookable_shipments/recommendations`}
    {...props}
  />
)

export type UseBookableShipmentRecommendationsProps = Omit<
  UseGetProps<
    BookableShipmentRecommendationsResponse,
    unknown,
    BookableShipmentRecommendationsQueryParams,
    void
  >,
  'path'
>

/**
 * Get load recommendations for user
 */
export const useBookableShipmentRecommendations = (
  props: UseBookableShipmentRecommendationsProps
) =>
  useGet<
    BookableShipmentRecommendationsResponse,
    unknown,
    BookableShipmentRecommendationsQueryParams,
    void
  >(`/bookable_shipments/recommendations`, props)

export interface GetBookableShipmentSavedSearchesResponse {
  bookableShipmentSavedSearches?: BookableShipmentSavedSearch[]
}

export type GetBookableShipmentSavedSearchesProps = Omit<
  GetProps<GetBookableShipmentSavedSearchesResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves the user's saved searches
 */
export const GetBookableShipmentSavedSearches = (props: GetBookableShipmentSavedSearchesProps) => (
  <Get<GetBookableShipmentSavedSearchesResponse, unknown, void, void>
    path={`/bookable_shipments/saved_searches`}
    {...props}
  />
)

export type UseGetBookableShipmentSavedSearchesProps = Omit<
  UseGetProps<GetBookableShipmentSavedSearchesResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves the user's saved searches
 */
export const useGetBookableShipmentSavedSearches = (
  props: UseGetBookableShipmentSavedSearchesProps
) =>
  useGet<GetBookableShipmentSavedSearchesResponse, unknown, void, void>(
    `/bookable_shipments/saved_searches`,
    props
  )

export interface CreateBookableShipmentSavedSearchResponse {
  bookableShipmentSavedSearch?: BookableShipmentSavedSearch
}

export type CreateBookableShipmentSavedSearchRequestBody = {
  bookableShipmentSavedSearch?: BookableShipmentSavedSearch & {
    motorCarrierId?: number
  }
}

export type CreateBookableShipmentSavedSearchProps = Omit<
  MutateProps<
    CreateBookableShipmentSavedSearchResponse,
    unknown,
    void,
    CreateBookableShipmentSavedSearchRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Creates a new saved search
 */
export const CreateBookableShipmentSavedSearch = (
  props: CreateBookableShipmentSavedSearchProps
) => (
  <Mutate<
    CreateBookableShipmentSavedSearchResponse,
    unknown,
    void,
    CreateBookableShipmentSavedSearchRequestBody,
    void
  >
    verb='POST'
    path={`/bookable_shipments/saved_searches`}
    {...props}
  />
)

export type UseCreateBookableShipmentSavedSearchProps = Omit<
  UseMutateProps<
    CreateBookableShipmentSavedSearchResponse,
    unknown,
    void,
    CreateBookableShipmentSavedSearchRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Creates a new saved search
 */
export const useCreateBookableShipmentSavedSearch = (
  props: UseCreateBookableShipmentSavedSearchProps
) =>
  useMutate<
    CreateBookableShipmentSavedSearchResponse,
    unknown,
    void,
    CreateBookableShipmentSavedSearchRequestBody,
    void
  >('POST', `/bookable_shipments/saved_searches`, props)

export type DeleteBookableShipmentSavedSearchProps = Omit<
  MutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Deletes the saved search
 */
export const DeleteBookableShipmentSavedSearch = (
  props: DeleteBookableShipmentSavedSearchProps
) => (
  <Mutate<void, unknown, void, number, void>
    verb='DELETE'
    path={`/bookable_shipments/saved_searches`}
    {...props}
  />
)

export type UseDeleteBookableShipmentSavedSearchProps = Omit<
  UseMutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Deletes the saved search
 */
export const useDeleteBookableShipmentSavedSearch = (
  props: UseDeleteBookableShipmentSavedSearchProps
) =>
  useMutate<void, unknown, void, number, void>('DELETE', `/bookable_shipments/saved_searches`, {
    ...props,
  })

export interface UpdateBookableShipmentSavedSearchResponse {
  bookableShipmentSavedSearch?: BookableShipmentSavedSearch
}

export interface UpdateBookableShipmentSavedSearchPathParams {
  id: number
}

export type UpdateBookableShipmentSavedSearchRequestBody = {
  bookableShipmentSavedSearch?: BookableShipmentSavedSearch & {
    motorCarrierId?: number
  }
}

export type UpdateBookableShipmentSavedSearchProps = Omit<
  MutateProps<
    UpdateBookableShipmentSavedSearchResponse,
    unknown,
    void,
    UpdateBookableShipmentSavedSearchRequestBody,
    UpdateBookableShipmentSavedSearchPathParams
  >,
  'path' | 'verb'
> &
  UpdateBookableShipmentSavedSearchPathParams

/**
 * Updates the saved search
 */
export const UpdateBookableShipmentSavedSearch = ({
  id,
  ...props
}: UpdateBookableShipmentSavedSearchProps) => (
  <Mutate<
    UpdateBookableShipmentSavedSearchResponse,
    unknown,
    void,
    UpdateBookableShipmentSavedSearchRequestBody,
    UpdateBookableShipmentSavedSearchPathParams
  >
    verb='PUT'
    path={`/bookable_shipments/saved_searches/${id}`}
    {...props}
  />
)

export type UseUpdateBookableShipmentSavedSearchProps = Omit<
  UseMutateProps<
    UpdateBookableShipmentSavedSearchResponse,
    unknown,
    void,
    UpdateBookableShipmentSavedSearchRequestBody,
    UpdateBookableShipmentSavedSearchPathParams
  >,
  'path' | 'verb'
> &
  UpdateBookableShipmentSavedSearchPathParams

/**
 * Updates the saved search
 */
export const useUpdateBookableShipmentSavedSearch = ({
  id,
  ...props
}: UseUpdateBookableShipmentSavedSearchProps) =>
  useMutate<
    UpdateBookableShipmentSavedSearchResponse,
    unknown,
    void,
    UpdateBookableShipmentSavedSearchRequestBody,
    UpdateBookableShipmentSavedSearchPathParams
  >(
    'PUT',
    (paramsInPath: UpdateBookableShipmentSavedSearchPathParams) =>
      `/bookable_shipments/saved_searches/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface BookableShipmentSearchResponse {
  auctionShipments: AuctionShipment[]
  totalCount: number
}

export interface BookableShipmentSearchQueryParams {
  /**
   * How to filter the results
   */
  filters?: BookableShipmentSavedSearch
  /**
   * Which page of results to return
   */
  pageNumber?: number
  /**
   * How many results to return per page
   */
  pageSize?: number
  /**
   * Field to use for sorting results
   */
  sortField?: string
  /**
   * Direction to sort results
   */
  sortOrder?: string
  /**
   * Optional ID of an existing saved search. If provided, the saved search is executed instead of an ad-hoc search using the `filters` parameter. If `{pickup,delivery}Miles` are provided in `filters`, those attributes are updated on the existing saved search per Product rules.
   */
  savedSearchId?: number
}

export type BookableShipmentSearchProps = Omit<
  GetProps<BookableShipmentSearchResponse, unknown, BookableShipmentSearchQueryParams, void>,
  'path'
>

/**
 * Search bookable shipments
 */
export const BookableShipmentSearch = (props: BookableShipmentSearchProps) => (
  <Get<BookableShipmentSearchResponse, unknown, BookableShipmentSearchQueryParams, void>
    path={`/bookable_shipments/search`}
    {...props}
  />
)

export type UseBookableShipmentSearchProps = Omit<
  UseGetProps<BookableShipmentSearchResponse, unknown, BookableShipmentSearchQueryParams, void>,
  'path'
>

/**
 * Search bookable shipments
 */
export const useBookableShipmentSearch = (props: UseBookableShipmentSearchProps) =>
  useGet<BookableShipmentSearchResponse, unknown, BookableShipmentSearchQueryParams, void>(
    `/bookable_shipments/search`,
    props
  )

export interface GetCarrierBidsResponse {
  bids: BidResponse[]
}

export type GetCarrierBidsProps = Omit<
  GetProps<GetCarrierBidsResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves a list of bids for the current user's carriers
 */
export const GetCarrierBids = (props: GetCarrierBidsProps) => (
  <Get<GetCarrierBidsResponse, unknown, void, void> path={`/carrier_bids`} {...props} />
)

export type UseGetCarrierBidsProps = Omit<
  UseGetProps<GetCarrierBidsResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves a list of bids for the current user's carriers
 */
export const useGetCarrierBids = (props: UseGetCarrierBidsProps) =>
  useGet<GetCarrierBidsResponse, unknown, void, void>(`/carrier_bids`, props)

export type GetCarrierBidResponse = {
  bid: BidResponse | null
}

export type GetCarrierBidProps = Omit<GetProps<GetCarrierBidResponse, unknown, void, void>, 'path'>

/**
 * Retrieves the most recent bid data for the current user's carriers
 */
export const GetCarrierBid = (props: GetCarrierBidProps) => (
  <Get<GetCarrierBidResponse, unknown, void, void> path={`/carrier_bids/:id`} {...props} />
)

export type UseGetCarrierBidProps = Omit<
  UseGetProps<GetCarrierBidResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves the most recent bid data for the current user's carriers
 */
export const useGetCarrierBid = (props: UseGetCarrierBidProps) =>
  useGet<GetCarrierBidResponse, unknown, void, void>(`/carrier_bids/:id`, props)

export interface GetContactResponse {
  contact?: Contact
}

export interface GetContactPathParams {
  id: number
}

export type GetContactProps = Omit<
  GetProps<GetContactResponse, unknown, void, GetContactPathParams>,
  'path'
> &
  GetContactPathParams

/**
 * Retrieves a contact
 */
export const GetContact = ({ id, ...props }: GetContactProps) => (
  <Get<GetContactResponse, unknown, void, GetContactPathParams>
    path={`/contacts/${id}`}
    {...props}
  />
)

export type UseGetContactProps = Omit<
  UseGetProps<GetContactResponse, unknown, void, GetContactPathParams>,
  'path'
> &
  GetContactPathParams

/**
 * Retrieves a contact
 */
export const useGetContact = ({ id, ...props }: UseGetContactProps) =>
  useGet<GetContactResponse, unknown, void, GetContactPathParams>(
    (paramsInPath: GetContactPathParams) => `/contacts/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export type GetUsersResponse = {
  motor_carriers?: MotorCarrier[]
  user?: User | null
}

export type GetUsersProps = Omit<GetProps<GetUsersResponse, unknown, void, void>, 'path'>

/**
 * Retrieves information about the current user
 */
export const GetUsers = (props: GetUsersProps) => (
  <Get<GetUsersResponse, unknown, void, void> path={`/current_user`} {...props} />
)

export type UseGetUsersProps = Omit<UseGetProps<GetUsersResponse, unknown, void, void>, 'path'>

/**
 * Retrieves information about the current user
 */
export const useGetUsers = (props: UseGetUsersProps) =>
  useGet<GetUsersResponse, unknown, void, void>(`/current_user`, props)

export interface UpdateUsersResponse {
  user?: User
}

export interface UpdateUsersRequestBody {
  user?: User
}

export type UpdateUsersProps = Omit<
  MutateProps<UpdateUsersResponse, unknown, void, UpdateUsersRequestBody, void>,
  'path' | 'verb'
>

/**
 * Updates attributes for the current user
 */
export const UpdateUsers = (props: UpdateUsersProps) => (
  <Mutate<UpdateUsersResponse, unknown, void, UpdateUsersRequestBody, void>
    verb='PUT'
    path={`/current_user`}
    {...props}
  />
)

export type UseUpdateUsersProps = Omit<
  UseMutateProps<UpdateUsersResponse, unknown, void, UpdateUsersRequestBody, void>,
  'path' | 'verb'
>

/**
 * Updates attributes for the current user
 */
export const useUpdateUsers = (props: UseUpdateUsersProps) =>
  useMutate<UpdateUsersResponse, unknown, void, UpdateUsersRequestBody, void>(
    'PUT',
    `/current_user`,
    props
  )

export interface GetCurrentUserMotorCarriersResponse {
  motor_carriers?: MotorCarrierForUser[]
}

export type GetCurrentUserMotorCarriersProps = Omit<
  GetProps<GetCurrentUserMotorCarriersResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves a list of MCs and the user's relationship to them
 */
export const GetCurrentUserMotorCarriers = (props: GetCurrentUserMotorCarriersProps) => (
  <Get<GetCurrentUserMotorCarriersResponse, unknown, void, void>
    path={`/current_user/motor_carriers`}
    {...props}
  />
)

export type UseGetCurrentUserMotorCarriersProps = Omit<
  UseGetProps<GetCurrentUserMotorCarriersResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves a list of MCs and the user's relationship to them
 */
export const useGetCurrentUserMotorCarriers = (props: UseGetCurrentUserMotorCarriersProps) =>
  useGet<GetCurrentUserMotorCarriersResponse, unknown, void, void>(
    `/current_user/motor_carriers`,
    props
  )

export interface JoinCurrentUserMotorCarrierResponse {
  motor_carriers?: MotorCarrierForUser[]
}

export interface JoinCurrentUserMotorCarrierRequestBody {
  motor_carriers?: MotorCarrier[]
}

export type JoinCurrentUserMotorCarrierProps = Omit<
  MutateProps<
    JoinCurrentUserMotorCarrierResponse,
    unknown,
    void,
    JoinCurrentUserMotorCarrierRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Adds the current user to the provided MCs, or requests to join them
 */
export const JoinCurrentUserMotorCarrier = (props: JoinCurrentUserMotorCarrierProps) => (
  <Mutate<
    JoinCurrentUserMotorCarrierResponse,
    unknown,
    void,
    JoinCurrentUserMotorCarrierRequestBody,
    void
  >
    verb='POST'
    path={`/current_user/motor_carriers/join`}
    {...props}
  />
)

export type UseJoinCurrentUserMotorCarrierProps = Omit<
  UseMutateProps<
    JoinCurrentUserMotorCarrierResponse,
    unknown,
    void,
    JoinCurrentUserMotorCarrierRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Adds the current user to the provided MCs, or requests to join them
 */
export const useJoinCurrentUserMotorCarrier = (props: UseJoinCurrentUserMotorCarrierProps) =>
  useMutate<
    JoinCurrentUserMotorCarrierResponse,
    unknown,
    void,
    JoinCurrentUserMotorCarrierRequestBody,
    void
  >('POST', `/current_user/motor_carriers/join`, props)

export type DeleteCurrentUserMotorCarrierProps = Omit<
  MutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Removes the current user from the provided MC
 */
export const DeleteCurrentUserMotorCarrier = (props: DeleteCurrentUserMotorCarrierProps) => (
  <Mutate<void, unknown, void, number, void>
    verb='DELETE'
    path={`/current_user/motor_carriers`}
    {...props}
  />
)

export type UseDeleteCurrentUserMotorCarrierProps = Omit<
  UseMutateProps<void, unknown, void, number, void>,
  'path' | 'verb'
>

/**
 * Removes the current user from the provided MC
 */
export const useDeleteCurrentUserMotorCarrier = (props: UseDeleteCurrentUserMotorCarrierProps) =>
  useMutate<void, unknown, void, number, void>('DELETE', `/current_user/motor_carriers`, {
    ...props,
  })

export interface UpdateOnboardingFlagResponse {
  user?: User
}

export interface UpdateOnboardingFlagRequestBody {
  onboarding?: UserOnboarding
}

export type UpdateOnboardingFlagProps = Omit<
  MutateProps<UpdateOnboardingFlagResponse, unknown, void, UpdateOnboardingFlagRequestBody, void>,
  'path' | 'verb'
>

/**
 * Updates onboarding flag(s) for the current user
 */
export const UpdateOnboardingFlag = (props: UpdateOnboardingFlagProps) => (
  <Mutate<UpdateOnboardingFlagResponse, unknown, void, UpdateOnboardingFlagRequestBody, void>
    verb='PUT'
    path={`/current_user/onboarding`}
    {...props}
  />
)

export type UseUpdateOnboardingFlagProps = Omit<
  UseMutateProps<
    UpdateOnboardingFlagResponse,
    unknown,
    void,
    UpdateOnboardingFlagRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Updates onboarding flag(s) for the current user
 */
export const useUpdateOnboardingFlag = (props: UseUpdateOnboardingFlagProps) =>
  useMutate<UpdateOnboardingFlagResponse, unknown, void, UpdateOnboardingFlagRequestBody, void>(
    'PUT',
    `/current_user/onboarding`,
    props
  )

export interface UpdateUserSettingsResponse {
  user?: User
}

export interface UpdateUserSettingsRequestBody {
  settings?: UserSettings
}

export type UpdateUserSettingsProps = Omit<
  MutateProps<UpdateUserSettingsResponse, unknown, void, UpdateUserSettingsRequestBody, void>,
  'path' | 'verb'
>

/**
 * Updates settings for the current user
 */
export const UpdateUserSettings = (props: UpdateUserSettingsProps) => (
  <Mutate<UpdateUserSettingsResponse, unknown, void, UpdateUserSettingsRequestBody, void>
    verb='PUT'
    path={`/current_user/settings`}
    {...props}
  />
)

export type UseUpdateUserSettingsProps = Omit<
  UseMutateProps<UpdateUserSettingsResponse, unknown, void, UpdateUserSettingsRequestBody, void>,
  'path' | 'verb'
>

/**
 * Updates settings for the current user
 */
export const useUpdateUserSettings = (props: UseUpdateUserSettingsProps) =>
  useMutate<UpdateUserSettingsResponse, unknown, void, UpdateUserSettingsRequestBody, void>(
    'PUT',
    `/current_user/settings`,
    props
  )

export interface GetCustomersResponse {
  customers?: Customer[]
}

export interface GetCustomersQueryParams {
  /**
   * How to filter the results
   */
  filters?: CustomerFilters
  /**
   * Which page of results to return
   */
  page_number?: number
  /**
   * How many results to return per page
   */
  page_size?: number
  /**
   * Field to use for sorting results
   */
  sort_field?: string
  /**
   * Direction to sort results
   */
  sort_order?: string
}

export type GetCustomersProps = Omit<
  GetProps<GetCustomersResponse, unknown, GetCustomersQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of customers
 */
export const GetCustomers = (props: GetCustomersProps) => (
  <Get<GetCustomersResponse, unknown, GetCustomersQueryParams, void>
    path={`/customers`}
    {...props}
  />
)

export type UseGetCustomersProps = Omit<
  UseGetProps<GetCustomersResponse, unknown, GetCustomersQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of customers
 */
export const useGetCustomers = (props: UseGetCustomersProps) =>
  useGet<GetCustomersResponse, unknown, GetCustomersQueryParams, void>(`/customers`, props)

export interface CreateCustomerResponse {
  customer?: Customer
}

export interface CreateCustomerRequestBody {
  customer?: Customer
}

export type CreateCustomerProps = Omit<
  MutateProps<CreateCustomerResponse, unknown, void, CreateCustomerRequestBody, void>,
  'path' | 'verb'
>

/**
 * Creates a new customer
 */
export const CreateCustomer = (props: CreateCustomerProps) => (
  <Mutate<CreateCustomerResponse, unknown, void, CreateCustomerRequestBody, void>
    verb='POST'
    path={`/customers`}
    {...props}
  />
)

export type UseCreateCustomerProps = Omit<
  UseMutateProps<CreateCustomerResponse, unknown, void, CreateCustomerRequestBody, void>,
  'path' | 'verb'
>

/**
 * Creates a new customer
 */
export const useCreateCustomer = (props: UseCreateCustomerProps) =>
  useMutate<CreateCustomerResponse, unknown, void, CreateCustomerRequestBody, void>(
    'POST',
    `/customers`,
    props
  )

export interface UpdateCustomerContactResponse {
  contact?: Contact
}

export interface UpdateCustomerContactPathParams {
  customer_id: number
  id: number
}

export type UpdateCustomerContactProps = Omit<
  MutateProps<
    UpdateCustomerContactResponse,
    unknown,
    void,
    Contact,
    UpdateCustomerContactPathParams
  >,
  'path' | 'verb'
> &
  UpdateCustomerContactPathParams

/**
 * Updates an existing contact for a customer
 */
export const UpdateCustomerContact = ({
  customer_id,
  id,
  ...props
}: UpdateCustomerContactProps) => (
  <Mutate<UpdateCustomerContactResponse, unknown, void, Contact, UpdateCustomerContactPathParams>
    verb='PUT'
    path={`/customers/${customer_id}/contacts/${id}`}
    {...props}
  />
)

export type UseUpdateCustomerContactProps = Omit<
  UseMutateProps<
    UpdateCustomerContactResponse,
    unknown,
    void,
    Contact,
    UpdateCustomerContactPathParams
  >,
  'path' | 'verb'
> &
  UpdateCustomerContactPathParams

/**
 * Updates an existing contact for a customer
 */
export const useUpdateCustomerContact = ({
  customer_id,
  id,
  ...props
}: UseUpdateCustomerContactProps) =>
  useMutate<UpdateCustomerContactResponse, unknown, void, Contact, UpdateCustomerContactPathParams>(
    'PUT',
    (paramsInPath: UpdateCustomerContactPathParams) =>
      `/customers/${paramsInPath.customer_id}/contacts/${paramsInPath.id}`,
    { pathParams: { customer_id, id }, ...props }
  )

export interface UpdateCustomerResponse {
  customer?: Customer
}

export interface UpdateCustomerPathParams {
  id: number
}

export type UpdateCustomerProps = Omit<
  MutateProps<
    UpdateCustomerResponse,
    unknown,
    void,
    CustomerWithoutAssociations,
    UpdateCustomerPathParams
  >,
  'path' | 'verb'
> &
  UpdateCustomerPathParams

/**
 * Updates an existing customer
 */
export const UpdateCustomer = ({ id, ...props }: UpdateCustomerProps) => (
  <Mutate<
    UpdateCustomerResponse,
    unknown,
    void,
    CustomerWithoutAssociations,
    UpdateCustomerPathParams
  >
    verb='PUT'
    path={`/customers/${id}`}
    {...props}
  />
)

export type UseUpdateCustomerProps = Omit<
  UseMutateProps<
    UpdateCustomerResponse,
    unknown,
    void,
    CustomerWithoutAssociations,
    UpdateCustomerPathParams
  >,
  'path' | 'verb'
> &
  UpdateCustomerPathParams

/**
 * Updates an existing customer
 */
export const useUpdateCustomer = ({ id, ...props }: UseUpdateCustomerProps) =>
  useMutate<
    UpdateCustomerResponse,
    unknown,
    void,
    CustomerWithoutAssociations,
    UpdateCustomerPathParams
  >('PUT', (paramsInPath: UpdateCustomerPathParams) => `/customers/${paramsInPath.id}`, {
    pathParams: { id },
    ...props,
  })

export interface CreateCustomerContactResponse {
  contact?: Contact
}

export interface CreateCustomerContactPathParams {
  id: number
}

export type CreateCustomerContactProps = Omit<
  MutateProps<
    CreateCustomerContactResponse,
    unknown,
    void,
    Contact,
    CreateCustomerContactPathParams
  >,
  'path' | 'verb'
> &
  CreateCustomerContactPathParams

/**
 * Creates a new contact for a customer
 */
export const CreateCustomerContact = ({ id, ...props }: CreateCustomerContactProps) => (
  <Mutate<CreateCustomerContactResponse, unknown, void, Contact, CreateCustomerContactPathParams>
    verb='POST'
    path={`/customers/${id}/contacts`}
    {...props}
  />
)

export type UseCreateCustomerContactProps = Omit<
  UseMutateProps<
    CreateCustomerContactResponse,
    unknown,
    void,
    Contact,
    CreateCustomerContactPathParams
  >,
  'path' | 'verb'
> &
  CreateCustomerContactPathParams

/**
 * Creates a new contact for a customer
 */
export const useCreateCustomerContact = ({ id, ...props }: UseCreateCustomerContactProps) =>
  useMutate<CreateCustomerContactResponse, unknown, void, Contact, CreateCustomerContactPathParams>(
    'POST',
    (paramsInPath: CreateCustomerContactPathParams) => `/customers/${paramsInPath.id}/contacts`,
    { pathParams: { id }, ...props }
  )

export interface DedicatedLanesContactUsRequestBody {
  email?: string
  lane_id?: number
  message?: string
  phone?: string
}

export type DedicatedLanesContactUsProps = Omit<
  MutateProps<void, unknown, void, DedicatedLanesContactUsRequestBody, void>,
  'path' | 'verb'
>

/**
 * Sends a contact us email to a transfix person
 */
export const DedicatedLanesContactUs = (props: DedicatedLanesContactUsProps) => (
  <Mutate<void, unknown, void, DedicatedLanesContactUsRequestBody, void>
    verb='POST'
    path={`/dedicated_lanes/contact`}
    {...props}
  />
)

export type UseDedicatedLanesContactUsProps = Omit<
  UseMutateProps<void, unknown, void, DedicatedLanesContactUsRequestBody, void>,
  'path' | 'verb'
>

/**
 * Sends a contact us email to a transfix person
 */
export const useDedicatedLanesContactUs = (props: UseDedicatedLanesContactUsProps) =>
  useMutate<void, unknown, void, DedicatedLanesContactUsRequestBody, void>(
    'POST',
    `/dedicated_lanes/contact`,
    props
  )

export interface GetDedicatedLanesContractsResponse {
  dedicatedLanes?: DedicatedLane[]
}

export type GetDedicatedLanesContractsProps = Omit<
  GetProps<GetDedicatedLanesContractsResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves a list of contracted lanes for this user
 */
export const GetDedicatedLanesContracts = (props: GetDedicatedLanesContractsProps) => (
  <Get<GetDedicatedLanesContractsResponse, unknown, void, void>
    path={`/dedicated_lanes/contracts`}
    {...props}
  />
)

export type UseGetDedicatedLanesContractsProps = Omit<
  UseGetProps<GetDedicatedLanesContractsResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves a list of contracted lanes for this user
 */
export const useGetDedicatedLanesContracts = (props: UseGetDedicatedLanesContractsProps) =>
  useGet<GetDedicatedLanesContractsResponse, unknown, void, void>(
    `/dedicated_lanes/contracts`,
    props
  )

export interface DedicatedLanesUpdateSMSResponse {
  laneId: string
}

export interface DedicatedLanesUpdateSMSPathParams {
  id: number
}

export interface DedicatedLanesUpdateSMSRequestBody {
  lane: {
    smsNotificationsEnabled: boolean
  }
}

export type DedicatedLanesUpdateSMSProps = Omit<
  MutateProps<
    DedicatedLanesUpdateSMSResponse,
    unknown,
    void,
    DedicatedLanesUpdateSMSRequestBody,
    DedicatedLanesUpdateSMSPathParams
  >,
  'path' | 'verb'
> &
  DedicatedLanesUpdateSMSPathParams

/**
 * Updates SMS notifications setting for dedicated lane
 */
export const DedicatedLanesUpdateSMS = ({ id, ...props }: DedicatedLanesUpdateSMSProps) => (
  <Mutate<
    DedicatedLanesUpdateSMSResponse,
    unknown,
    void,
    DedicatedLanesUpdateSMSRequestBody,
    DedicatedLanesUpdateSMSPathParams
  >
    verb='PUT'
    path={`/dedicated_lanes/${id}`}
    {...props}
  />
)

export type UseDedicatedLanesUpdateSMSProps = Omit<
  UseMutateProps<
    DedicatedLanesUpdateSMSResponse,
    unknown,
    void,
    DedicatedLanesUpdateSMSRequestBody,
    DedicatedLanesUpdateSMSPathParams
  >,
  'path' | 'verb'
> &
  DedicatedLanesUpdateSMSPathParams

/**
 * Updates SMS notifications setting for dedicated lane
 */
export const useDedicatedLanesUpdateSMS = ({ id, ...props }: UseDedicatedLanesUpdateSMSProps) =>
  useMutate<
    DedicatedLanesUpdateSMSResponse,
    unknown,
    void,
    DedicatedLanesUpdateSMSRequestBody,
    DedicatedLanesUpdateSMSPathParams
  >(
    'PUT',
    (paramsInPath: DedicatedLanesUpdateSMSPathParams) => `/dedicated_lanes/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface GetDedicatedLanesBidsResponse {
  dedicatedLanesBids?: DedicatedLanesBid[]
}

export type GetDedicatedLanesBidsProps = Omit<
  GetProps<GetDedicatedLanesBidsResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves a list of dedicated lanes bids
 */
export const GetDedicatedLanesBids = (props: GetDedicatedLanesBidsProps) => (
  <Get<GetDedicatedLanesBidsResponse, unknown, void, void>
    path={`/dedicated_lanes_bids`}
    {...props}
  />
)

export type UseGetDedicatedLanesBidsProps = Omit<
  UseGetProps<GetDedicatedLanesBidsResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieves a list of dedicated lanes bids
 */
export const useGetDedicatedLanesBids = (props: UseGetDedicatedLanesBidsProps) =>
  useGet<GetDedicatedLanesBidsResponse, unknown, void, void>(`/dedicated_lanes_bids`, props)

export interface CreateDedicatedLanesBidResponse {
  dedicatedLanesBid?: DedicatedLanesBid
}

export interface CreateDedicatedLanesBidRequestBody {
  dedicatedLanesBid?: DedicatedLanesBid
}

export type CreateDedicatedLanesBidProps = Omit<
  MutateProps<
    CreateDedicatedLanesBidResponse,
    unknown,
    void,
    CreateDedicatedLanesBidRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Create a bid for a dedicated lane
 */
export const CreateDedicatedLanesBid = (props: CreateDedicatedLanesBidProps) => (
  <Mutate<CreateDedicatedLanesBidResponse, unknown, void, CreateDedicatedLanesBidRequestBody, void>
    verb='POST'
    path={`/dedicated_lanes_bids`}
    {...props}
  />
)

export type UseCreateDedicatedLanesBidProps = Omit<
  UseMutateProps<
    CreateDedicatedLanesBidResponse,
    unknown,
    void,
    CreateDedicatedLanesBidRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Create a bid for a dedicated lane
 */
export const useCreateDedicatedLanesBid = (props: UseCreateDedicatedLanesBidProps) =>
  useMutate<
    CreateDedicatedLanesBidResponse,
    unknown,
    void,
    CreateDedicatedLanesBidRequestBody,
    void
  >('POST', `/dedicated_lanes_bids`, props)

export interface CreateDedicatedLanesInquireResponse {
  dedicated_lanes_bid_inquire?: DedicatedLanesBidInquire
}

export interface CreateDedicatedLanesInquireRequestBody {
  dedicated_lanes_bid_inquire?: DedicatedLanesBidInquire
}

export type CreateDedicatedLanesInquireProps = Omit<
  MutateProps<
    CreateDedicatedLanesInquireResponse,
    unknown,
    void,
    CreateDedicatedLanesInquireRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Submit inquiry for a dedicated lane
 */
export const CreateDedicatedLanesInquire = (props: CreateDedicatedLanesInquireProps) => (
  <Mutate<
    CreateDedicatedLanesInquireResponse,
    unknown,
    void,
    CreateDedicatedLanesInquireRequestBody,
    void
  >
    verb='POST'
    path={`/dedicated_lanes_bids/inquire`}
    {...props}
  />
)

export type UseCreateDedicatedLanesInquireProps = Omit<
  UseMutateProps<
    CreateDedicatedLanesInquireResponse,
    unknown,
    void,
    CreateDedicatedLanesInquireRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Submit inquiry for a dedicated lane
 */
export const useCreateDedicatedLanesInquire = (props: UseCreateDedicatedLanesInquireProps) =>
  useMutate<
    CreateDedicatedLanesInquireResponse,
    unknown,
    void,
    CreateDedicatedLanesInquireRequestBody,
    void
  >('POST', `/dedicated_lanes_bids/inquire`, props)

export interface GetDispatchersResponse {
  dispatchers?: Dispatcher[]
}

export interface GetDispatchersQueryParams {
  full_name?: string
  motor_carrier_id?: number
}

export type GetDispatchersProps = Omit<
  GetProps<GetDispatchersResponse, unknown, GetDispatchersQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of dispatchers
 */
export const GetDispatchers = (props: GetDispatchersProps) => (
  <Get<GetDispatchersResponse, unknown, GetDispatchersQueryParams, void>
    path={`/dispatchers`}
    {...props}
  />
)

export type UseGetDispatchersProps = Omit<
  UseGetProps<GetDispatchersResponse, unknown, GetDispatchersQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of dispatchers
 */
export const useGetDispatchers = (props: UseGetDispatchersProps) =>
  useGet<GetDispatchersResponse, unknown, GetDispatchersQueryParams, void>(`/dispatchers`, props)

export interface GetDriverValidationShipmentResponse {
  share?: Share
  shipment?: Shipment
  statusShare?: Share
}

export type GetDriverValidationShipmentProps = Omit<
  GetProps<GetDriverValidationShipmentResponse, void, void, void>,
  'path'
>

/**
 * Retrieves a shipment using a driver validation share token
 *
 * Retrieve a shipment to display to the driver in the validation flow
 */
export const GetDriverValidationShipment = (props: GetDriverValidationShipmentProps) => (
  <Get<GetDriverValidationShipmentResponse, void, void, void>
    path={`/driver_validation`}
    {...props}
  />
)

export type UseGetDriverValidationShipmentProps = Omit<
  UseGetProps<GetDriverValidationShipmentResponse, void, void, void>,
  'path'
>

/**
 * Retrieves a shipment using a driver validation share token
 *
 * Retrieve a shipment to display to the driver in the validation flow
 */
export const useGetDriverValidationShipment = (props: UseGetDriverValidationShipmentProps) =>
  useGet<GetDriverValidationShipmentResponse, void, void, void>(`/driver_validation`, props)

export interface ActivateQrResponse {
  share?: Share
}

export type ActivateQrProps = Omit<
  MutateProps<ActivateQrResponse, void, void, void, void>,
  'path' | 'verb'
>

/**
 * Creates a share token to power the QR code shown by the driver
 *
 * Generate a share-token to power the driver fraud verification QR
 */
export const ActivateQr = (props: ActivateQrProps) => (
  <Mutate<ActivateQrResponse, void, void, void, void>
    verb='PUT'
    path={`/driver_validation/activate`}
    {...props}
  />
)

export type UseActivateQrProps = Omit<
  UseMutateProps<ActivateQrResponse, void, void, void, void>,
  'path' | 'verb'
>

/**
 * Creates a share token to power the QR code shown by the driver
 *
 * Generate a share-token to power the driver fraud verification QR
 */
export const useActivateQr = (props: UseActivateQrProps) =>
  useMutate<ActivateQrResponse, void, void, void, void>('PUT', `/driver_validation/activate`, props)

export interface GetDriverVerificationShipmentResponse {
  share?: Share
  shipment?: Shipment
}

export type GetDriverVerificationShipmentProps = Omit<
  GetProps<GetDriverVerificationShipmentResponse, void, void, void>,
  'path'
>

/**
 * Retrieves a shipment using a driver verification share token
 *
 * Retrieve a shipment to display success to the shipper facility guard in the validation flow
 */
export const GetDriverVerificationShipment = (props: GetDriverVerificationShipmentProps) => (
  <Get<GetDriverVerificationShipmentResponse, void, void, void>
    path={`/driver_verification`}
    {...props}
  />
)

export type UseGetDriverVerificationShipmentProps = Omit<
  UseGetProps<GetDriverVerificationShipmentResponse, void, void, void>,
  'path'
>

/**
 * Retrieves a shipment using a driver verification share token
 *
 * Retrieve a shipment to display success to the shipper facility guard in the validation flow
 */
export const useGetDriverVerificationShipment = (props: UseGetDriverVerificationShipmentProps) =>
  useGet<GetDriverVerificationShipmentResponse, void, void, void>(`/driver_verification`, props)

export interface GetDriversResponse {
  drivers?: Driver[]
}

export type GetDriversProps = Omit<GetProps<GetDriversResponse, unknown, void, void>, 'path'>

/**
 * Retrieves a list of drivers for specific motor carrier
 *
 * Returns all drivers for the user specific MC, sorted by ascending name
 */
export const GetDrivers = (props: GetDriversProps) => (
  <Get<GetDriversResponse, unknown, void, void> path={`/drivers`} {...props} />
)

export type UseGetDriversProps = Omit<UseGetProps<GetDriversResponse, unknown, void, void>, 'path'>

/**
 * Retrieves a list of drivers for specific motor carrier
 *
 * Returns all drivers for the user specific MC, sorted by ascending name
 */
export const useGetDrivers = (props: UseGetDriversProps) =>
  useGet<GetDriversResponse, unknown, void, void>(`/drivers`, props)

export interface CreateDriverResponse {
  driver?: Driver
}

export type CreateDriverProps = Omit<
  MutateProps<CreateDriverResponse, unknown, void, Driver, void>,
  'path' | 'verb'
>

/**
 * Creates a new driver
 */
export const CreateDriver = (props: CreateDriverProps) => (
  <Mutate<CreateDriverResponse, unknown, void, Driver, void>
    verb='POST'
    path={`/drivers`}
    {...props}
  />
)

export type UseCreateDriverProps = Omit<
  UseMutateProps<CreateDriverResponse, unknown, void, Driver, void>,
  'path' | 'verb'
>

/**
 * Creates a new driver
 */
export const useCreateDriver = (props: UseCreateDriverProps) =>
  useMutate<CreateDriverResponse, unknown, void, Driver, void>('POST', `/drivers`, props)

export interface UpdateDriverResponse {
  driver?: Driver
}

export interface UpdateDriverPathParams {
  id: number
}

export type UpdateDriverProps = Omit<
  MutateProps<UpdateDriverResponse, unknown, void, Driver, UpdateDriverPathParams>,
  'path' | 'verb'
> &
  UpdateDriverPathParams

/**
 * Updates an existing driver
 */
export const UpdateDriver = ({ id, ...props }: UpdateDriverProps) => (
  <Mutate<UpdateDriverResponse, unknown, void, Driver, UpdateDriverPathParams>
    verb='PUT'
    path={`/drivers/${id}`}
    {...props}
  />
)

export type UseUpdateDriverProps = Omit<
  UseMutateProps<UpdateDriverResponse, unknown, void, Driver, UpdateDriverPathParams>,
  'path' | 'verb'
> &
  UpdateDriverPathParams

/**
 * Updates an existing driver
 */
export const useUpdateDriver = ({ id, ...props }: UseUpdateDriverProps) =>
  useMutate<UpdateDriverResponse, unknown, void, Driver, UpdateDriverPathParams>(
    'PUT',
    (paramsInPath: UpdateDriverPathParams) => `/drivers/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface GetEquipmentResponse {
  trailers?: Trailer[]
  trucks?: Truck[]
}

export interface GetEquipmentQueryParams {
  /**
   * Optional Motor Carrier ID for filtering trucks/trailers
   */
  motor_carrier_id?: string
  /**
   * How to filter the results
   */
  filters?: EquipmentFilters
}

export type GetEquipmentProps = Omit<
  GetProps<GetEquipmentResponse, unknown, GetEquipmentQueryParams, void>,
  'path'
>

/**
 * Retrieves lists of trucks and trailers
 */
export const GetEquipment = (props: GetEquipmentProps) => (
  <Get<GetEquipmentResponse, unknown, GetEquipmentQueryParams, void>
    path={`/equipment`}
    {...props}
  />
)

export type UseGetEquipmentProps = Omit<
  UseGetProps<GetEquipmentResponse, unknown, GetEquipmentQueryParams, void>,
  'path'
>

/**
 * Retrieves lists of trucks and trailers
 */
export const useGetEquipment = (props: UseGetEquipmentProps) =>
  useGet<GetEquipmentResponse, unknown, GetEquipmentQueryParams, void>(`/equipment`, props)

export interface GetExternalShipmentsResponse {
  fp_shipment_id?: number
}

export interface GetExternalShipmentsPathParams {
  external_id: number
}

export type GetExternalShipmentsProps = Omit<
  GetProps<GetExternalShipmentsResponse, unknown, void, GetExternalShipmentsPathParams>,
  'path'
> &
  GetExternalShipmentsPathParams

/**
 * Retrieves the fp shipment id
 *
 * Returns a null shipment_id if the shipment does not exist
 */
export const GetExternalShipments = ({ external_id, ...props }: GetExternalShipmentsProps) => (
  <Get<GetExternalShipmentsResponse, unknown, void, GetExternalShipmentsPathParams>
    path={`/external_shipments/marketplace/${external_id}`}
    {...props}
  />
)

export type UseGetExternalShipmentsProps = Omit<
  UseGetProps<GetExternalShipmentsResponse, unknown, void, GetExternalShipmentsPathParams>,
  'path'
> &
  GetExternalShipmentsPathParams

/**
 * Retrieves the fp shipment id
 *
 * Returns a null shipment_id if the shipment does not exist
 */
export const useGetExternalShipments = ({ external_id, ...props }: UseGetExternalShipmentsProps) =>
  useGet<GetExternalShipmentsResponse, unknown, void, GetExternalShipmentsPathParams>(
    (paramsInPath: GetExternalShipmentsPathParams) =>
      `/external_shipments/marketplace/${paramsInPath.external_id}`,
    { pathParams: { external_id }, ...props }
  )

export interface GetFacilitiesResponse {
  facilities?: Facility[]
}

export interface GetFacilitiesQueryParams {
  /**
   * How to filter the results
   */
  filters?: FacilityFilters
  /**
   * Which page of results to return
   */
  page_number?: number
  /**
   * How many results to return per page
   */
  page_size?: number
  /**
   * Field to use for sorting results
   */
  sort_field?: string
  /**
   * Direction to sort results
   */
  sort_order?: string
}

export type GetFacilitiesProps = Omit<
  GetProps<GetFacilitiesResponse, unknown, GetFacilitiesQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of facilities
 */
export const GetFacilities = (props: GetFacilitiesProps) => (
  <Get<GetFacilitiesResponse, unknown, GetFacilitiesQueryParams, void>
    path={`/facilities`}
    {...props}
  />
)

export type UseGetFacilitiesProps = Omit<
  UseGetProps<GetFacilitiesResponse, unknown, GetFacilitiesQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of facilities
 */
export const useGetFacilities = (props: UseGetFacilitiesProps) =>
  useGet<GetFacilitiesResponse, unknown, GetFacilitiesQueryParams, void>(`/facilities`, props)

export interface CreateFacilityResponse {
  facility?: Facility
}

export type CreateFacilityProps = Omit<
  MutateProps<CreateFacilityResponse, unknown, void, Facility, void>,
  'path' | 'verb'
>

/**
 * Creates a new facility
 */
export const CreateFacility = (props: CreateFacilityProps) => (
  <Mutate<CreateFacilityResponse, unknown, void, Facility, void>
    verb='POST'
    path={`/facilities`}
    {...props}
  />
)

export type UseCreateFacilityProps = Omit<
  UseMutateProps<CreateFacilityResponse, unknown, void, Facility, void>,
  'path' | 'verb'
>

/**
 * Creates a new facility
 */
export const useCreateFacility = (props: UseCreateFacilityProps) =>
  useMutate<CreateFacilityResponse, unknown, void, Facility, void>('POST', `/facilities`, props)

export interface UpdateAddressResponse {
  address?: Address
}

export interface UpdateAddressPathParams {
  facility_id: number
  id: number
}

export type UpdateAddressProps = Omit<
  MutateProps<UpdateAddressResponse, unknown, void, Address, UpdateAddressPathParams>,
  'path' | 'verb'
> &
  UpdateAddressPathParams

/**
 * Updates an existing address for a facility
 */
export const UpdateAddress = ({ facility_id, id, ...props }: UpdateAddressProps) => (
  <Mutate<UpdateAddressResponse, unknown, void, Address, UpdateAddressPathParams>
    verb='PUT'
    path={`/facilities/${facility_id}/addresses/${id}`}
    {...props}
  />
)

export type UseUpdateAddressProps = Omit<
  UseMutateProps<UpdateAddressResponse, unknown, void, Address, UpdateAddressPathParams>,
  'path' | 'verb'
> &
  UpdateAddressPathParams

/**
 * Updates an existing address for a facility
 */
export const useUpdateAddress = ({ facility_id, id, ...props }: UseUpdateAddressProps) =>
  useMutate<UpdateAddressResponse, unknown, void, Address, UpdateAddressPathParams>(
    'PUT',
    (paramsInPath: UpdateAddressPathParams) =>
      `/facilities/${paramsInPath.facility_id}/addresses/${paramsInPath.id}`,
    { pathParams: { facility_id, id }, ...props }
  )

export interface UpdateFacilityContactResponse {
  contact?: Contact
}

export interface UpdateFacilityContactPathParams {
  facility_id: number
  id: number
}

export type UpdateFacilityContactProps = Omit<
  MutateProps<
    UpdateFacilityContactResponse,
    unknown,
    void,
    Contact,
    UpdateFacilityContactPathParams
  >,
  'path' | 'verb'
> &
  UpdateFacilityContactPathParams

/**
 * Updates an existing contact for a facility
 */
export const UpdateFacilityContact = ({
  facility_id,
  id,
  ...props
}: UpdateFacilityContactProps) => (
  <Mutate<UpdateFacilityContactResponse, unknown, void, Contact, UpdateFacilityContactPathParams>
    verb='PUT'
    path={`/facilities/${facility_id}/contacts/${id}`}
    {...props}
  />
)

export type UseUpdateFacilityContactProps = Omit<
  UseMutateProps<
    UpdateFacilityContactResponse,
    unknown,
    void,
    Contact,
    UpdateFacilityContactPathParams
  >,
  'path' | 'verb'
> &
  UpdateFacilityContactPathParams

/**
 * Updates an existing contact for a facility
 */
export const useUpdateFacilityContact = ({
  facility_id,
  id,
  ...props
}: UseUpdateFacilityContactProps) =>
  useMutate<UpdateFacilityContactResponse, unknown, void, Contact, UpdateFacilityContactPathParams>(
    'PUT',
    (paramsInPath: UpdateFacilityContactPathParams) =>
      `/facilities/${paramsInPath.facility_id}/contacts/${paramsInPath.id}`,
    { pathParams: { facility_id, id }, ...props }
  )

export interface GetFacilityResponse {
  facility?: Facility
}

export interface GetFacilityPathParams {
  id: number
}

export type GetFacilityProps = Omit<
  GetProps<GetFacilityResponse, unknown, void, GetFacilityPathParams>,
  'path'
> &
  GetFacilityPathParams

/**
 * Retrieves a facility
 */
export const GetFacility = ({ id, ...props }: GetFacilityProps) => (
  <Get<GetFacilityResponse, unknown, void, GetFacilityPathParams>
    path={`/facilities/${id}`}
    {...props}
  />
)

export type UseGetFacilityProps = Omit<
  UseGetProps<GetFacilityResponse, unknown, void, GetFacilityPathParams>,
  'path'
> &
  GetFacilityPathParams

/**
 * Retrieves a facility
 */
export const useGetFacility = ({ id, ...props }: UseGetFacilityProps) =>
  useGet<GetFacilityResponse, unknown, void, GetFacilityPathParams>(
    (paramsInPath: GetFacilityPathParams) => `/facilities/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface UpdateFacilityResponse {
  facility?: Facility
}

export interface UpdateFacilityPathParams {
  id: number
}

export type UpdateFacilityProps = Omit<
  MutateProps<UpdateFacilityResponse, unknown, void, Facility, UpdateFacilityPathParams>,
  'path' | 'verb'
> &
  UpdateFacilityPathParams

/**
 * Updates an existing facility
 *
 * This API also accepts arrays of associated addresses and contacts. If an array of addresses or contacts is provided, any existing resource whose ID is not included in the request will be deleted. Exsting resources may be udpated by providing their ID within the updated object. New resources may be created by including a NULL ID inside of an object.
 */
export const UpdateFacility = ({ id, ...props }: UpdateFacilityProps) => (
  <Mutate<UpdateFacilityResponse, unknown, void, Facility, UpdateFacilityPathParams>
    verb='PUT'
    path={`/facilities/${id}`}
    {...props}
  />
)

export type UseUpdateFacilityProps = Omit<
  UseMutateProps<UpdateFacilityResponse, unknown, void, Facility, UpdateFacilityPathParams>,
  'path' | 'verb'
> &
  UpdateFacilityPathParams

/**
 * Updates an existing facility
 *
 * This API also accepts arrays of associated addresses and contacts. If an array of addresses or contacts is provided, any existing resource whose ID is not included in the request will be deleted. Exsting resources may be udpated by providing their ID within the updated object. New resources may be created by including a NULL ID inside of an object.
 */
export const useUpdateFacility = ({ id, ...props }: UseUpdateFacilityProps) =>
  useMutate<UpdateFacilityResponse, unknown, void, Facility, UpdateFacilityPathParams>(
    'PUT',
    (paramsInPath: UpdateFacilityPathParams) => `/facilities/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface CreateFacilityContactResponse {
  contact?: Contact
}

export interface CreateFacilityContactPathParams {
  id: number
}

export type CreateFacilityContactProps = Omit<
  MutateProps<
    CreateFacilityContactResponse,
    unknown,
    void,
    Contact,
    CreateFacilityContactPathParams
  >,
  'path' | 'verb'
> &
  CreateFacilityContactPathParams

/**
 * Creates a new contact for a facility
 */
export const CreateFacilityContact = ({ id, ...props }: CreateFacilityContactProps) => (
  <Mutate<CreateFacilityContactResponse, unknown, void, Contact, CreateFacilityContactPathParams>
    verb='POST'
    path={`/facilities/${id}/contacts`}
    {...props}
  />
)

export type UseCreateFacilityContactProps = Omit<
  UseMutateProps<
    CreateFacilityContactResponse,
    unknown,
    void,
    Contact,
    CreateFacilityContactPathParams
  >,
  'path' | 'verb'
> &
  CreateFacilityContactPathParams

/**
 * Creates a new contact for a facility
 */
export const useCreateFacilityContact = ({ id, ...props }: UseCreateFacilityContactProps) =>
  useMutate<CreateFacilityContactResponse, unknown, void, Contact, CreateFacilityContactPathParams>(
    'POST',
    (paramsInPath: CreateFacilityContactPathParams) => `/facilities/${paramsInPath.id}/contacts`,
    { pathParams: { id }, ...props }
  )

export interface GetFleetShipmentsResponse {
  shipments?: Shipment[]
}

export interface GetFleetShipmentsQueryParams {
  /**
   * start timestamp to filter shipments (includes shipments that start before this timestamp but with any stops after this timestamp)
   */
  start_at: TimestampWithTimezone
  /**
   * end timestamp to filter shipments (includes shipments that end after this timestamp but with any stops before this timestamp)
   */
  end_at: TimestampWithTimezone
}

export type GetFleetShipmentsProps = Omit<
  GetProps<GetFleetShipmentsResponse, unknown, GetFleetShipmentsQueryParams, void>,
  'path'
>

/**
 * Gets fleet shipments
 *
 * Gets a list of shipments within a given date range, sorted by driver first, and then by first pickup start datetime
 */
export const GetFleetShipments = (props: GetFleetShipmentsProps) => (
  <Get<GetFleetShipmentsResponse, unknown, GetFleetShipmentsQueryParams, void>
    path={`/fleet`}
    {...props}
  />
)

export type UseGetFleetShipmentsProps = Omit<
  UseGetProps<GetFleetShipmentsResponse, unknown, GetFleetShipmentsQueryParams, void>,
  'path'
>

/**
 * Gets fleet shipments
 *
 * Gets a list of shipments within a given date range, sorted by driver first, and then by first pickup start datetime
 */
export const useGetFleetShipments = (props: UseGetFleetShipmentsProps) =>
  useGet<GetFleetShipmentsResponse, unknown, GetFleetShipmentsQueryParams, void>(`/fleet`, props)

export interface GuidedBidsMeetsThresholdRequestBody {
  bidAmount?: string
  shipmentId?: string
  sourceChannel?: string
  sourceSegment?: string
}

export type GuidedBidsMeetsThresholdProps = Omit<
  MutateProps<
    GuidedBidsMeetsThresholdResponse,
    {
      errors?: {}[]
    },
    void,
    GuidedBidsMeetsThresholdRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Check if a bid amount is within range
 */
export const GuidedBidsMeetsThreshold = (props: GuidedBidsMeetsThresholdProps) => (
  <Mutate<
    GuidedBidsMeetsThresholdResponse,
    {
      errors?: {}[]
    },
    void,
    GuidedBidsMeetsThresholdRequestBody,
    void
  >
    verb='POST'
    path={`/guided_bids/meets_threshold`}
    {...props}
  />
)

export type UseGuidedBidsMeetsThresholdProps = Omit<
  UseMutateProps<
    GuidedBidsMeetsThresholdResponse,
    {
      errors?: {}[]
    },
    void,
    GuidedBidsMeetsThresholdRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Check if a bid amount is within range
 */
export const useGuidedBidsMeetsThreshold = (props: UseGuidedBidsMeetsThresholdProps) =>
  useMutate<
    GuidedBidsMeetsThresholdResponse,
    {
      errors?: {}[]
    },
    void,
    GuidedBidsMeetsThresholdRequestBody,
    void
  >('POST', `/guided_bids/meets_threshold`, props)

export interface KeepTruckinExchangeAuthCodeResponse {
  motorCarrierId?: number
}

export type KeepTruckinExchangeAuthCodeProps = Omit<
  MutateProps<KeepTruckinExchangeAuthCodeResponse, unknown, void, KeepTruckinAuthCode, void>,
  'path' | 'verb'
>

/**
 * store KT access token
 */
export const KeepTruckinExchangeAuthCode = (props: KeepTruckinExchangeAuthCodeProps) => (
  <Mutate<KeepTruckinExchangeAuthCodeResponse, unknown, void, KeepTruckinAuthCode, void>
    verb='POST'
    path={`/keep_truckin/oauth/exchange_auth_code_store`}
    {...props}
  />
)

export type UseKeepTruckinExchangeAuthCodeProps = Omit<
  UseMutateProps<KeepTruckinExchangeAuthCodeResponse, unknown, void, KeepTruckinAuthCode, void>,
  'path' | 'verb'
>

/**
 * store KT access token
 */
export const useKeepTruckinExchangeAuthCode = (props: UseKeepTruckinExchangeAuthCodeProps) =>
  useMutate<KeepTruckinExchangeAuthCodeResponse, unknown, void, KeepTruckinAuthCode, void>(
    'POST',
    `/keep_truckin/oauth/exchange_auth_code_store`,
    props
  )

export interface KeepTruckinGrantUrlResponse {
  grantUrl?: string
}

export interface KeepTruckinGrantUrlQueryParams {
  motorCarrierId?: string
}

export type KeepTruckinGrantUrlProps = Omit<
  GetProps<KeepTruckinGrantUrlResponse, unknown, KeepTruckinGrantUrlQueryParams, void>,
  'path'
>

/**
 * Retrieve user grant url
 */
export const KeepTruckinGrantUrl = (props: KeepTruckinGrantUrlProps) => (
  <Get<KeepTruckinGrantUrlResponse, unknown, KeepTruckinGrantUrlQueryParams, void>
    path={`/keep_truckin/oauth/grant_url`}
    {...props}
  />
)

export type UseKeepTruckinGrantUrlProps = Omit<
  UseGetProps<KeepTruckinGrantUrlResponse, unknown, KeepTruckinGrantUrlQueryParams, void>,
  'path'
>

/**
 * Retrieve user grant url
 */
export const useKeepTruckinGrantUrl = (props: UseKeepTruckinGrantUrlProps) =>
  useGet<KeepTruckinGrantUrlResponse, unknown, KeepTruckinGrantUrlQueryParams, void>(
    `/keep_truckin/oauth/grant_url`,
    props
  )

export interface KeepTruckinImportTrucksResponse {
  trucks?: Truck[]
}

export interface KeepTruckinImportTrucksRequestBody {
  motorCarrierId?: number
  trucks?: {
    /**
     * Keep Truckin truck id
     */
    id?: number
    /**
     * Truck number
     */
    number?: string
    vin?: string
  }[]
}

export type KeepTruckinImportTrucksProps = Omit<
  MutateProps<
    KeepTruckinImportTrucksResponse,
    unknown,
    void,
    KeepTruckinImportTrucksRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * imports trucks from keep truckin
 */
export const KeepTruckinImportTrucks = (props: KeepTruckinImportTrucksProps) => (
  <Mutate<KeepTruckinImportTrucksResponse, unknown, void, KeepTruckinImportTrucksRequestBody, void>
    verb='POST'
    path={`/keep_truckin/trucks/import`}
    {...props}
  />
)

export type UseKeepTruckinImportTrucksProps = Omit<
  UseMutateProps<
    KeepTruckinImportTrucksResponse,
    unknown,
    void,
    KeepTruckinImportTrucksRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * imports trucks from keep truckin
 */
export const useKeepTruckinImportTrucks = (props: UseKeepTruckinImportTrucksProps) =>
  useMutate<
    KeepTruckinImportTrucksResponse,
    unknown,
    void,
    KeepTruckinImportTrucksRequestBody,
    void
  >('POST', `/keep_truckin/trucks/import`, props)

export interface GetMotorCarrierJoinRequestResponse {
  motor_carrier_join_request?: MotorCarrierJoinRequest
}

export interface GetMotorCarrierJoinRequestPathParams {
  id: number
}

export type GetMotorCarrierJoinRequestProps = Omit<
  GetProps<GetMotorCarrierJoinRequestResponse, unknown, void, GetMotorCarrierJoinRequestPathParams>,
  'path'
> &
  GetMotorCarrierJoinRequestPathParams

/**
 * Retrieves the motor carrier join request
 */
export const GetMotorCarrierJoinRequest = ({ id, ...props }: GetMotorCarrierJoinRequestProps) => (
  <Get<GetMotorCarrierJoinRequestResponse, unknown, void, GetMotorCarrierJoinRequestPathParams>
    path={`/motor_carrier_join_requests/${id}`}
    {...props}
  />
)

export type UseGetMotorCarrierJoinRequestProps = Omit<
  UseGetProps<
    GetMotorCarrierJoinRequestResponse,
    unknown,
    void,
    GetMotorCarrierJoinRequestPathParams
  >,
  'path'
> &
  GetMotorCarrierJoinRequestPathParams

/**
 * Retrieves the motor carrier join request
 */
export const useGetMotorCarrierJoinRequest = ({
  id,
  ...props
}: UseGetMotorCarrierJoinRequestProps) =>
  useGet<GetMotorCarrierJoinRequestResponse, unknown, void, GetMotorCarrierJoinRequestPathParams>(
    (paramsInPath: GetMotorCarrierJoinRequestPathParams) =>
      `/motor_carrier_join_requests/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface UpdateMotorCarrierJoinRequestResponse {
  motor_carrier_join_request?: MotorCarrierJoinRequest
}

export interface UpdateMotorCarrierJoinRequestQueryParams {
  role?: string
  user_type?: string
}

export interface UpdateMotorCarrierJoinRequestPathParams {
  id: number
}

export type UpdateMotorCarrierJoinRequestProps = Omit<
  MutateProps<
    UpdateMotorCarrierJoinRequestResponse,
    unknown,
    UpdateMotorCarrierJoinRequestQueryParams,
    void,
    UpdateMotorCarrierJoinRequestPathParams
  >,
  'path' | 'verb'
> &
  UpdateMotorCarrierJoinRequestPathParams

/**
 * Approves the motor carrier join request
 */
export const UpdateMotorCarrierJoinRequest = ({
  id,
  ...props
}: UpdateMotorCarrierJoinRequestProps) => (
  <Mutate<
    UpdateMotorCarrierJoinRequestResponse,
    unknown,
    UpdateMotorCarrierJoinRequestQueryParams,
    void,
    UpdateMotorCarrierJoinRequestPathParams
  >
    verb='PUT'
    path={`/motor_carrier_join_requests/${id}/approve`}
    {...props}
  />
)

export type UseUpdateMotorCarrierJoinRequestProps = Omit<
  UseMutateProps<
    UpdateMotorCarrierJoinRequestResponse,
    unknown,
    UpdateMotorCarrierJoinRequestQueryParams,
    void,
    UpdateMotorCarrierJoinRequestPathParams
  >,
  'path' | 'verb'
> &
  UpdateMotorCarrierJoinRequestPathParams

/**
 * Approves the motor carrier join request
 */
export const useUpdateMotorCarrierJoinRequest = ({
  id,
  ...props
}: UseUpdateMotorCarrierJoinRequestProps) =>
  useMutate<
    UpdateMotorCarrierJoinRequestResponse,
    unknown,
    UpdateMotorCarrierJoinRequestQueryParams,
    void,
    UpdateMotorCarrierJoinRequestPathParams
  >(
    'PUT',
    (paramsInPath: UpdateMotorCarrierJoinRequestPathParams) =>
      `/motor_carrier_join_requests/${paramsInPath.id}/approve`,
    { pathParams: { id }, ...props }
  )

export interface GetMotorCarriersResponse {
  motor_carriers?: MotorCarrier[]
}

export interface GetMotorCarriersQueryParams {
  /**
   * Field to use for sorting results
   */
  sort_field?: string
  /**
   * Direction to sort results
   */
  sort_order?: string
}

export type GetMotorCarriersProps = Omit<
  GetProps<GetMotorCarriersResponse, unknown, GetMotorCarriersQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of MCs associated with the current user
 */
export const GetMotorCarriers = (props: GetMotorCarriersProps) => (
  <Get<GetMotorCarriersResponse, unknown, GetMotorCarriersQueryParams, void>
    path={`/motor_carriers`}
    {...props}
  />
)

export type UseGetMotorCarriersProps = Omit<
  UseGetProps<GetMotorCarriersResponse, unknown, GetMotorCarriersQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of MCs associated with the current user
 */
export const useGetMotorCarriers = (props: UseGetMotorCarriersProps) =>
  useGet<GetMotorCarriersResponse, unknown, GetMotorCarriersQueryParams, void>(
    `/motor_carriers`,
    props
  )

export interface SearchMotorCarriersResponse {
  motor_carrier?: MotorCarrier
}

export interface SearchMotorCarriersQueryParams {
  mc_number?: number
  dot_number?: number
}

export type SearchMotorCarriersProps = Omit<
  GetProps<SearchMotorCarriersResponse, unknown, SearchMotorCarriersQueryParams, void>,
  'path'
>

/**
 * Finds an MC by MC number or DOT number, looking up the data in the FMCSA database if necessary
 *
 * Note that the request must include at least one of the optional querystring params.
 */
export const SearchMotorCarriers = (props: SearchMotorCarriersProps) => (
  <Get<SearchMotorCarriersResponse, unknown, SearchMotorCarriersQueryParams, void>
    path={`/motor_carriers/search`}
    {...props}
  />
)

export type UseSearchMotorCarriersProps = Omit<
  UseGetProps<SearchMotorCarriersResponse, unknown, SearchMotorCarriersQueryParams, void>,
  'path'
>

/**
 * Finds an MC by MC number or DOT number, looking up the data in the FMCSA database if necessary
 *
 * Note that the request must include at least one of the optional querystring params.
 */
export const useSearchMotorCarriers = (props: UseSearchMotorCarriersProps) =>
  useGet<SearchMotorCarriersResponse, unknown, SearchMotorCarriersQueryParams, void>(
    `/motor_carriers/search`,
    props
  )

export interface GetAllOfferedShipmentsResponse {
  offeredShipments?: OfferedShipment[]
  totalCount?: {}
}

export type GetAllOfferedShipmentsProps = Omit<
  MutateProps<GetAllOfferedShipmentsResponse, unknown, void, void, void>,
  'path' | 'verb'
>

/**
 * Fetches all the offered shipments for the current user
 */
export const GetAllOfferedShipments = (props: GetAllOfferedShipmentsProps) => (
  <Mutate<GetAllOfferedShipmentsResponse, unknown, void, void, void>
    verb='POST'
    path={`/offered_shipments/all`}
    {...props}
  />
)

export type UseGetAllOfferedShipmentsProps = Omit<
  UseMutateProps<GetAllOfferedShipmentsResponse, unknown, void, void, void>,
  'path' | 'verb'
>

/**
 * Fetches all the offered shipments for the current user
 */
export const useGetAllOfferedShipments = (props: UseGetAllOfferedShipmentsProps) =>
  useMutate<GetAllOfferedShipmentsResponse, unknown, void, void, void>(
    'POST',
    `/offered_shipments/all`,
    props
  )

export interface GetCurrentOfferedShipmentsResponse {
  offeredShipments?: OfferedShipment[]
  totalCount?: {}
}

export type GetCurrentOfferedShipmentsProps = Omit<
  MutateProps<
    GetCurrentOfferedShipmentsResponse,
    {
      errors?: {}[]
    },
    void,
    void,
    void
  >,
  'path' | 'verb'
>

/**
 * Returns the error messages and status code
 */
export const GetCurrentOfferedShipments = (props: GetCurrentOfferedShipmentsProps) => (
  <Mutate<
    GetCurrentOfferedShipmentsResponse,
    {
      errors?: {}[]
    },
    void,
    void,
    void
  >
    verb='POST'
    path={`/offered_shipments/current`}
    {...props}
  />
)

export type UseGetCurrentOfferedShipmentsProps = Omit<
  UseMutateProps<
    GetCurrentOfferedShipmentsResponse,
    {
      errors?: {}[]
    },
    void,
    void,
    void
  >,
  'path' | 'verb'
>

/**
 * Returns the error messages and status code
 */
export const useGetCurrentOfferedShipments = (props: UseGetCurrentOfferedShipmentsProps) =>
  useMutate<
    GetCurrentOfferedShipmentsResponse,
    {
      errors?: {}[]
    },
    void,
    void,
    void
  >('POST', `/offered_shipments/current`, props)

export interface GetPastOfferedShipmentsResponse {
  pastOffers?: OfferedShipment[]
  totalCount?: {}
}

export type GetPastOfferedShipmentsProps = Omit<
  MutateProps<GetPastOfferedShipmentsResponse, unknown, void, void, void>,
  'path' | 'verb'
>

/**
 * Fetches all the offered shipments for the current user
 */
export const GetPastOfferedShipments = (props: GetPastOfferedShipmentsProps) => (
  <Mutate<GetPastOfferedShipmentsResponse, unknown, void, void, void>
    verb='POST'
    path={`/offered_shipments/past`}
    {...props}
  />
)

export type UseGetPastOfferedShipmentsProps = Omit<
  UseMutateProps<GetPastOfferedShipmentsResponse, unknown, void, void, void>,
  'path' | 'verb'
>

/**
 * Fetches all the offered shipments for the current user
 */
export const useGetPastOfferedShipments = (props: UseGetPastOfferedShipmentsProps) =>
  useMutate<GetPastOfferedShipmentsResponse, unknown, void, void, void>(
    'POST',
    `/offered_shipments/past`,
    props
  )

export interface GetPublicTruckAvailabilityResponse {
  bookableShipmentSavedSearches?: BookableShipmentSavedSearch[]
}

export interface GetPublicTruckAvailabilityPathParams {
  uuid: string
}

export type GetPublicTruckAvailabilityProps = Omit<
  GetProps<GetPublicTruckAvailabilityResponse, unknown, void, GetPublicTruckAvailabilityPathParams>,
  'path'
> &
  GetPublicTruckAvailabilityPathParams

/**
 * Retrieves truck availability saved searches for a given dispatcher share id
 */
export const GetPublicTruckAvailability = ({ uuid, ...props }: GetPublicTruckAvailabilityProps) => (
  <Get<GetPublicTruckAvailabilityResponse, unknown, void, GetPublicTruckAvailabilityPathParams>
    path={`/public/truck_availability/${uuid}`}
    {...props}
  />
)

export type UseGetPublicTruckAvailabilityProps = Omit<
  UseGetProps<
    GetPublicTruckAvailabilityResponse,
    unknown,
    void,
    GetPublicTruckAvailabilityPathParams
  >,
  'path'
> &
  GetPublicTruckAvailabilityPathParams

/**
 * Retrieves truck availability saved searches for a given dispatcher share id
 */
export const useGetPublicTruckAvailability = ({
  uuid,
  ...props
}: UseGetPublicTruckAvailabilityProps) =>
  useGet<GetPublicTruckAvailabilityResponse, unknown, void, GetPublicTruckAvailabilityPathParams>(
    (paramsInPath: GetPublicTruckAvailabilityPathParams) =>
      `/public/truck_availability/${paramsInPath.uuid}`,
    { pathParams: { uuid }, ...props }
  )

export interface QuickbooksCreateInvoiceResponse {
  create_invoice_job_queued?: boolean
}

export type QuickbooksCreateInvoiceProps = Omit<
  MutateProps<QuickbooksCreateInvoiceResponse, unknown, void, BodyId, void>,
  'path' | 'verb'
>

/**
 * Enqueues a create invoice job
 */
export const QuickbooksCreateInvoice = (props: QuickbooksCreateInvoiceProps) => (
  <Mutate<QuickbooksCreateInvoiceResponse, unknown, void, BodyId, void>
    verb='POST'
    path={`/quickbooks/create_invoice`}
    {...props}
  />
)

export type UseQuickbooksCreateInvoiceProps = Omit<
  UseMutateProps<QuickbooksCreateInvoiceResponse, unknown, void, BodyId, void>,
  'path' | 'verb'
>

/**
 * Enqueues a create invoice job
 */
export const useQuickbooksCreateInvoice = (props: UseQuickbooksCreateInvoiceProps) =>
  useMutate<QuickbooksCreateInvoiceResponse, unknown, void, BodyId, void>(
    'POST',
    `/quickbooks/create_invoice`,
    props
  )

export interface QuickbooksExchangeAuthCodeResponse {
  success?: boolean
}

export type QuickbooksExchangeAuthCodeProps = Omit<
  MutateProps<QuickbooksExchangeAuthCodeResponse, unknown, void, QuickbooksAuthCode, void>,
  'path' | 'verb'
>

/**
 * store QB access token
 */
export const QuickbooksExchangeAuthCode = (props: QuickbooksExchangeAuthCodeProps) => (
  <Mutate<QuickbooksExchangeAuthCodeResponse, unknown, void, QuickbooksAuthCode, void>
    verb='POST'
    path={`/quickbooks_oauth/exchange_auth_code_store`}
    {...props}
  />
)

export type UseQuickbooksExchangeAuthCodeProps = Omit<
  UseMutateProps<QuickbooksExchangeAuthCodeResponse, unknown, void, QuickbooksAuthCode, void>,
  'path' | 'verb'
>

/**
 * store QB access token
 */
export const useQuickbooksExchangeAuthCode = (props: UseQuickbooksExchangeAuthCodeProps) =>
  useMutate<QuickbooksExchangeAuthCodeResponse, unknown, void, QuickbooksAuthCode, void>(
    'POST',
    `/quickbooks_oauth/exchange_auth_code_store`,
    props
  )

export interface QuickbooksGrantUrlResponse {
  grant_url?: string
}

export type QuickbooksGrantUrlProps = Omit<
  GetProps<QuickbooksGrantUrlResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieve user grant url
 */
export const QuickbooksGrantUrl = (props: QuickbooksGrantUrlProps) => (
  <Get<QuickbooksGrantUrlResponse, unknown, void, void>
    path={`/quickbooks_oauth/grant_url`}
    {...props}
  />
)

export type UseQuickbooksGrantUrlProps = Omit<
  UseGetProps<QuickbooksGrantUrlResponse, unknown, void, void>,
  'path'
>

/**
 * Retrieve user grant url
 */
export const useQuickbooksGrantUrl = (props: UseQuickbooksGrantUrlProps) =>
  useGet<QuickbooksGrantUrlResponse, unknown, void, void>(`/quickbooks_oauth/grant_url`, props)

export interface GetSharedShipmentResponse {
  shipment?: Shipment
}

export interface GetSharedShipmentPathParams {
  id: number
}

export type GetSharedShipmentProps = Omit<
  GetProps<GetSharedShipmentResponse, unknown, void, GetSharedShipmentPathParams>,
  'path'
> &
  GetSharedShipmentPathParams

/**
 * Retrieves a shared shipment using a share token
 *
 * Shipment fields will contain `null` values if the provided share token does not authorize viewing those fields.
 */
export const GetSharedShipment = ({ id, ...props }: GetSharedShipmentProps) => (
  <Get<GetSharedShipmentResponse, unknown, void, GetSharedShipmentPathParams>
    path={`/shared/shipments/${id}`}
    {...props}
  />
)

export type UseGetSharedShipmentProps = Omit<
  UseGetProps<GetSharedShipmentResponse, unknown, void, GetSharedShipmentPathParams>,
  'path'
> &
  GetSharedShipmentPathParams

/**
 * Retrieves a shared shipment using a share token
 *
 * Shipment fields will contain `null` values if the provided share token does not authorize viewing those fields.
 */
export const useGetSharedShipment = ({ id, ...props }: UseGetSharedShipmentProps) =>
  useGet<GetSharedShipmentResponse, unknown, void, GetSharedShipmentPathParams>(
    (paramsInPath: GetSharedShipmentPathParams) => `/shared/shipments/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface UpdateSharedShipmentResponse {
  shipment?: Shipment
}

export interface UpdateSharedShipmentQueryParams {
  /**
   * Share token for API access
   */
  shareToken: string
}

export interface UpdateSharedShipmentPathParams {
  id: number
}

export interface UpdateSharedShipmentRequestBody {
  shipment?: {
    trailerNumber?: string | null
  }
}

export type UpdateSharedShipmentProps = Omit<
  MutateProps<
    UpdateSharedShipmentResponse,
    unknown,
    UpdateSharedShipmentQueryParams,
    UpdateSharedShipmentRequestBody,
    UpdateSharedShipmentPathParams
  >,
  'path' | 'verb'
> &
  UpdateSharedShipmentPathParams

/**
 * Updates a shared shipment using a share token
 */
export const UpdateSharedShipment = ({ id, ...props }: UpdateSharedShipmentProps) => (
  <Mutate<
    UpdateSharedShipmentResponse,
    unknown,
    UpdateSharedShipmentQueryParams,
    UpdateSharedShipmentRequestBody,
    UpdateSharedShipmentPathParams
  >
    verb='PUT'
    path={`/shared/shipments/${id}`}
    {...props}
  />
)

export type UseUpdateSharedShipmentProps = Omit<
  UseMutateProps<
    UpdateSharedShipmentResponse,
    unknown,
    UpdateSharedShipmentQueryParams,
    UpdateSharedShipmentRequestBody,
    UpdateSharedShipmentPathParams
  >,
  'path' | 'verb'
> &
  UpdateSharedShipmentPathParams

/**
 * Updates a shared shipment using a share token
 */
export const useUpdateSharedShipment = ({ id, ...props }: UseUpdateSharedShipmentProps) =>
  useMutate<
    UpdateSharedShipmentResponse,
    unknown,
    UpdateSharedShipmentQueryParams,
    UpdateSharedShipmentRequestBody,
    UpdateSharedShipmentPathParams
  >(
    'PUT',
    (paramsInPath: UpdateSharedShipmentPathParams) => `/shared/shipments/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface UpdateSharedShipmentAttachmentsResponse {
  shipment?: Shipment
}

export interface UpdateSharedShipmentAttachmentsPathParams {
  id: number
}

export interface UpdateSharedShipmentAttachmentsRequestBody {
  shipment?: {
    pods?: Attachment[]
  }
}

export type UpdateSharedShipmentAttachmentsProps = Omit<
  MutateProps<
    UpdateSharedShipmentAttachmentsResponse,
    unknown,
    void,
    UpdateSharedShipmentAttachmentsRequestBody,
    UpdateSharedShipmentAttachmentsPathParams
  >,
  'path' | 'verb'
> &
  UpdateSharedShipmentAttachmentsPathParams

/**
 * Updates a shipment's attachments
 */
export const UpdateSharedShipmentAttachments = ({
  id,
  ...props
}: UpdateSharedShipmentAttachmentsProps) => (
  <Mutate<
    UpdateSharedShipmentAttachmentsResponse,
    unknown,
    void,
    UpdateSharedShipmentAttachmentsRequestBody,
    UpdateSharedShipmentAttachmentsPathParams
  >
    verb='PUT'
    path={`/shared/shipments/${id}/attachments`}
    {...props}
  />
)

export type UseUpdateSharedShipmentAttachmentsProps = Omit<
  UseMutateProps<
    UpdateSharedShipmentAttachmentsResponse,
    unknown,
    void,
    UpdateSharedShipmentAttachmentsRequestBody,
    UpdateSharedShipmentAttachmentsPathParams
  >,
  'path' | 'verb'
> &
  UpdateSharedShipmentAttachmentsPathParams

/**
 * Updates a shipment's attachments
 */
export const useUpdateSharedShipmentAttachments = ({
  id,
  ...props
}: UseUpdateSharedShipmentAttachmentsProps) =>
  useMutate<
    UpdateSharedShipmentAttachmentsResponse,
    unknown,
    void,
    UpdateSharedShipmentAttachmentsRequestBody,
    UpdateSharedShipmentAttachmentsPathParams
  >(
    'PUT',
    (paramsInPath: UpdateSharedShipmentAttachmentsPathParams) =>
      `/shared/shipments/${paramsInPath.id}/attachments`,
    { pathParams: { id }, ...props }
  )

export interface UpdateSharedShipmentStatusResponse {
  shipment?: Shipment
}

export interface UpdateSharedShipmentStatusPathParams {
  id: number
}

export interface UpdateSharedShipmentStatusRequestBody {
  shipment?: {
    current_stop_sequence?: number | null
    status?: ShipmentStatus
    /**
     * The driver-provided check-in or check-out time for the status change, in UTC.
     */
    timestamp?: string | null
  }
}

export type UpdateSharedShipmentStatusProps = Omit<
  MutateProps<
    UpdateSharedShipmentStatusResponse,
    unknown,
    void,
    UpdateSharedShipmentStatusRequestBody,
    UpdateSharedShipmentStatusPathParams
  >,
  'path' | 'verb'
> &
  UpdateSharedShipmentStatusPathParams

/**
 * Updates a shipment's status
 *
 * The request should include the `status` and `current_stop_sequence` that the shipment is transitioning _to_.
 */
export const UpdateSharedShipmentStatus = ({ id, ...props }: UpdateSharedShipmentStatusProps) => (
  <Mutate<
    UpdateSharedShipmentStatusResponse,
    unknown,
    void,
    UpdateSharedShipmentStatusRequestBody,
    UpdateSharedShipmentStatusPathParams
  >
    verb='PUT'
    path={`/shared/shipments/${id}/status`}
    {...props}
  />
)

export type UseUpdateSharedShipmentStatusProps = Omit<
  UseMutateProps<
    UpdateSharedShipmentStatusResponse,
    unknown,
    void,
    UpdateSharedShipmentStatusRequestBody,
    UpdateSharedShipmentStatusPathParams
  >,
  'path' | 'verb'
> &
  UpdateSharedShipmentStatusPathParams

/**
 * Updates a shipment's status
 *
 * The request should include the `status` and `current_stop_sequence` that the shipment is transitioning _to_.
 */
export const useUpdateSharedShipmentStatus = ({
  id,
  ...props
}: UseUpdateSharedShipmentStatusProps) =>
  useMutate<
    UpdateSharedShipmentStatusResponse,
    unknown,
    void,
    UpdateSharedShipmentStatusRequestBody,
    UpdateSharedShipmentStatusPathParams
  >(
    'PUT',
    (paramsInPath: UpdateSharedShipmentStatusPathParams) =>
      `/shared/shipments/${paramsInPath.id}/status`,
    { pathParams: { id }, ...props }
  )

export interface SearchTrailersResponse {
  trailerNumbers?: string[]
}

export interface SearchTrailersQueryParams {
  /**
   * Search term for trailer filtering
   */
  term?: string
  /**
   * Share token for API access
   */
  shareToken: string
}

export interface SearchTrailersPathParams {
  id: number
}

export type SearchTrailersProps = Omit<
  GetProps<SearchTrailersResponse, unknown, SearchTrailersQueryParams, SearchTrailersPathParams>,
  'path'
> &
  SearchTrailersPathParams

/**
 * Provides autocomplete options for a trailer search
 */
export const SearchTrailers = ({ id, ...props }: SearchTrailersProps) => (
  <Get<SearchTrailersResponse, unknown, SearchTrailersQueryParams, SearchTrailersPathParams>
    path={`/shared/shipments/${id}/trailers/search`}
    {...props}
  />
)

export type UseSearchTrailersProps = Omit<
  UseGetProps<SearchTrailersResponse, unknown, SearchTrailersQueryParams, SearchTrailersPathParams>,
  'path'
> &
  SearchTrailersPathParams

/**
 * Provides autocomplete options for a trailer search
 */
export const useSearchTrailers = ({ id, ...props }: UseSearchTrailersProps) =>
  useGet<SearchTrailersResponse, unknown, SearchTrailersQueryParams, SearchTrailersPathParams>(
    (paramsInPath: SearchTrailersPathParams) =>
      `/shared/shipments/${paramsInPath.id}/trailers/search`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentStopCheckInOutResponse {}

export interface UpdateShipmentStopCheckInOutPathParams {
  shipment_id: number
  id: number
}

export interface UpdateShipmentStopCheckInOutRequestBody {
  stop?: {
    /**
     * The driver-provided check-in time, in UTC.
     */
    checked_in_at?: string | null
    /**
     * The driver-provided check-out time, in UTC.
     */
    checked_out_at?: string | null
  }
}

export type UpdateShipmentStopCheckInOutProps = Omit<
  MutateProps<
    UpdateShipmentStopCheckInOutResponse,
    unknown,
    void,
    UpdateShipmentStopCheckInOutRequestBody,
    UpdateShipmentStopCheckInOutPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentStopCheckInOutPathParams

/**
 * Updates a shipment stop's check-in or check-out time
 */
export const UpdateShipmentStopCheckInOut = ({
  shipment_id,
  id,
  ...props
}: UpdateShipmentStopCheckInOutProps) => (
  <Mutate<
    UpdateShipmentStopCheckInOutResponse,
    unknown,
    void,
    UpdateShipmentStopCheckInOutRequestBody,
    UpdateShipmentStopCheckInOutPathParams
  >
    verb='PATCH'
    path={`/shared/shipments/${shipment_id}/stops/${id}/check_in_out`}
    {...props}
  />
)

export type UseUpdateShipmentStopCheckInOutProps = Omit<
  UseMutateProps<
    UpdateShipmentStopCheckInOutResponse,
    unknown,
    void,
    UpdateShipmentStopCheckInOutRequestBody,
    UpdateShipmentStopCheckInOutPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentStopCheckInOutPathParams

/**
 * Updates a shipment stop's check-in or check-out time
 */
export const useUpdateShipmentStopCheckInOut = ({
  shipment_id,
  id,
  ...props
}: UseUpdateShipmentStopCheckInOutProps) =>
  useMutate<
    UpdateShipmentStopCheckInOutResponse,
    unknown,
    void,
    UpdateShipmentStopCheckInOutRequestBody,
    UpdateShipmentStopCheckInOutPathParams
  >(
    'PATCH',
    (paramsInPath: UpdateShipmentStopCheckInOutPathParams) =>
      `/shared/shipments/${paramsInPath.shipment_id}/stops/${paramsInPath.id}/check_in_out`,
    { pathParams: { shipment_id, id }, ...props }
  )

export interface GetShipmentsResponse {
  shipments?: Shipment[]
}

export interface GetShipmentsQueryParams {
  /**
   * How to filter the results
   */
  filters?: ShipmentFilters
  /**
   * Which page of results to return
   */
  page_number?: number
  /**
   * How many results to return per page
   */
  page_size?: number
  /**
   * Field to use for sorting results
   */
  sort_field?: string
  /**
   * Direction to sort results
   */
  sort_order?: string
}

export type GetShipmentsProps = Omit<
  GetProps<GetShipmentsResponse, unknown, GetShipmentsQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of shipments
 */
export const GetShipments = (props: GetShipmentsProps) => (
  <Get<GetShipmentsResponse, unknown, GetShipmentsQueryParams, void>
    path={`/shipments`}
    {...props}
  />
)

export type UseGetShipmentsProps = Omit<
  UseGetProps<GetShipmentsResponse, unknown, GetShipmentsQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of shipments
 */
export const useGetShipments = (props: UseGetShipmentsProps) =>
  useGet<GetShipmentsResponse, unknown, GetShipmentsQueryParams, void>(`/shipments`, props)

export interface CreateShipmentResponse {
  shipment?: Shipment
}

export type CreateShipmentProps = Omit<
  MutateProps<CreateShipmentResponse, unknown, void, ShipmentRequest, void>,
  'path' | 'verb'
>

/**
 * Creates a new shipment
 */
export const CreateShipment = (props: CreateShipmentProps) => (
  <Mutate<CreateShipmentResponse, unknown, void, ShipmentRequest, void>
    verb='POST'
    path={`/shipments`}
    {...props}
  />
)

export type UseCreateShipmentProps = Omit<
  UseMutateProps<CreateShipmentResponse, unknown, void, ShipmentRequest, void>,
  'path' | 'verb'
>

/**
 * Creates a new shipment
 */
export const useCreateShipment = (props: UseCreateShipmentProps) =>
  useMutate<CreateShipmentResponse, unknown, void, ShipmentRequest, void>(
    'POST',
    `/shipments`,
    props
  )

export interface GetShipmentResponse {
  shipment?: Shipment
}

export interface GetShipmentPathParams {
  id: number
}

export type GetShipmentProps = Omit<
  GetProps<GetShipmentResponse, unknown, void, GetShipmentPathParams>,
  'path'
> &
  GetShipmentPathParams

/**
 * Retrieves a shipment
 */
export const GetShipment = ({ id, ...props }: GetShipmentProps) => (
  <Get<GetShipmentResponse, unknown, void, GetShipmentPathParams>
    path={`/shipments/${id}`}
    {...props}
  />
)

export type UseGetShipmentProps = Omit<
  UseGetProps<GetShipmentResponse, unknown, void, GetShipmentPathParams>,
  'path'
> &
  GetShipmentPathParams

/**
 * Retrieves a shipment
 */
export const useGetShipment = ({ id, ...props }: UseGetShipmentProps) =>
  useGet<GetShipmentResponse, unknown, void, GetShipmentPathParams>(
    (paramsInPath: GetShipmentPathParams) => `/shipments/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentResponse {
  shipment?: Shipment
}

export interface UpdateShipmentPathParams {
  id: number
}

export type UpdateShipmentProps = Omit<
  MutateProps<UpdateShipmentResponse, unknown, void, ShipmentRequest, UpdateShipmentPathParams>,
  'path' | 'verb'
> &
  UpdateShipmentPathParams

/**
 * Updates a shipment
 *
 * NB: Many shipment and stop fields are not user-updateable on shipments from an external source, and are therefore ignored by this API for such shipments.
 */
export const UpdateShipment = ({ id, ...props }: UpdateShipmentProps) => (
  <Mutate<UpdateShipmentResponse, unknown, void, ShipmentRequest, UpdateShipmentPathParams>
    verb='PUT'
    path={`/shipments/${id}`}
    {...props}
  />
)

export type UseUpdateShipmentProps = Omit<
  UseMutateProps<UpdateShipmentResponse, unknown, void, ShipmentRequest, UpdateShipmentPathParams>,
  'path' | 'verb'
> &
  UpdateShipmentPathParams

/**
 * Updates a shipment
 *
 * NB: Many shipment and stop fields are not user-updateable on shipments from an external source, and are therefore ignored by this API for such shipments.
 */
export const useUpdateShipment = ({ id, ...props }: UseUpdateShipmentProps) =>
  useMutate<UpdateShipmentResponse, unknown, void, ShipmentRequest, UpdateShipmentPathParams>(
    'PUT',
    (paramsInPath: UpdateShipmentPathParams) => `/shipments/${paramsInPath.id}`,
    { pathParams: { id }, ...props }
  )

export interface GetActivitiesResponse {
  activities?: Activity[]
}

export interface GetActivitiesPathParams {
  id: number
}

export type GetActivitiesProps = Omit<
  GetProps<GetActivitiesResponse, unknown, void, GetActivitiesPathParams>,
  'path'
> &
  GetActivitiesPathParams

/**
 * Retrieves a list of activities for a shipment.
 */
export const GetActivities = ({ id, ...props }: GetActivitiesProps) => (
  <Get<GetActivitiesResponse, unknown, void, GetActivitiesPathParams>
    path={`/shipments/${id}/activities`}
    {...props}
  />
)

export type UseGetActivitiesProps = Omit<
  UseGetProps<GetActivitiesResponse, unknown, void, GetActivitiesPathParams>,
  'path'
> &
  GetActivitiesPathParams

/**
 * Retrieves a list of activities for a shipment.
 */
export const useGetActivities = ({ id, ...props }: UseGetActivitiesProps) =>
  useGet<GetActivitiesResponse, unknown, void, GetActivitiesPathParams>(
    (paramsInPath: GetActivitiesPathParams) => `/shipments/${paramsInPath.id}/activities`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentAssignmentResponse {
  shipment?: Shipment
}

export interface UpdateShipmentAssignmentPathParams {
  id: number
}

export interface UpdateShipmentAssignmentRequestBody {
  shipment?: {
    dispatcher_id?: number
    driver_ids?: number[] | null
    motor_carrier_id?: number
    tractor_vin?: string | null
    trailer_id?: number | null
    truck_id?: number | null
  }
}

export type UpdateShipmentAssignmentProps = Omit<
  MutateProps<
    UpdateShipmentAssignmentResponse,
    unknown,
    void,
    UpdateShipmentAssignmentRequestBody,
    UpdateShipmentAssignmentPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentAssignmentPathParams

/**
 * Updates a shipment's MC/dispatcher/driver/truck/trailer assignments
 */
export const UpdateShipmentAssignment = ({ id, ...props }: UpdateShipmentAssignmentProps) => (
  <Mutate<
    UpdateShipmentAssignmentResponse,
    unknown,
    void,
    UpdateShipmentAssignmentRequestBody,
    UpdateShipmentAssignmentPathParams
  >
    verb='PUT'
    path={`/shipments/${id}/assignment`}
    {...props}
  />
)

export type UseUpdateShipmentAssignmentProps = Omit<
  UseMutateProps<
    UpdateShipmentAssignmentResponse,
    unknown,
    void,
    UpdateShipmentAssignmentRequestBody,
    UpdateShipmentAssignmentPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentAssignmentPathParams

/**
 * Updates a shipment's MC/dispatcher/driver/truck/trailer assignments
 */
export const useUpdateShipmentAssignment = ({ id, ...props }: UseUpdateShipmentAssignmentProps) =>
  useMutate<
    UpdateShipmentAssignmentResponse,
    unknown,
    void,
    UpdateShipmentAssignmentRequestBody,
    UpdateShipmentAssignmentPathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipmentAssignmentPathParams) =>
      `/shipments/${paramsInPath.id}/assignment`,
    { pathParams: { id }, ...props }
  )

export interface GetCommentsResponse {
  comments?: Comment[]
}

export interface GetCommentsPathParams {
  id: number
}

export type GetCommentsProps = Omit<
  GetProps<GetCommentsResponse, unknown, void, GetCommentsPathParams>,
  'path'
> &
  GetCommentsPathParams

/**
 * Retrieves a list of comments for a shipment.
 */
export const GetComments = ({ id, ...props }: GetCommentsProps) => (
  <Get<GetCommentsResponse, unknown, void, GetCommentsPathParams>
    path={`/shipments/${id}/comments`}
    {...props}
  />
)

export type UseGetCommentsProps = Omit<
  UseGetProps<GetCommentsResponse, unknown, void, GetCommentsPathParams>,
  'path'
> &
  GetCommentsPathParams

/**
 * Retrieves a list of comments for a shipment.
 */
export const useGetComments = ({ id, ...props }: UseGetCommentsProps) =>
  useGet<GetCommentsResponse, unknown, void, GetCommentsPathParams>(
    (paramsInPath: GetCommentsPathParams) => `/shipments/${paramsInPath.id}/comments`,
    { pathParams: { id }, ...props }
  )

export interface CreateCommentResponse {
  comment?: Comment
}

export interface CreateCommentPathParams {
  id: number
}

export type CreateCommentProps = Omit<
  MutateProps<CreateCommentResponse, unknown, void, CommentCreate, CreateCommentPathParams>,
  'path' | 'verb'
> &
  CreateCommentPathParams

/**
 * Creates a new comment for a shipment
 */
export const CreateComment = ({ id, ...props }: CreateCommentProps) => (
  <Mutate<CreateCommentResponse, unknown, void, CommentCreate, CreateCommentPathParams>
    verb='POST'
    path={`/shipments/${id}/comments`}
    {...props}
  />
)

export type UseCreateCommentProps = Omit<
  UseMutateProps<CreateCommentResponse, unknown, void, CommentCreate, CreateCommentPathParams>,
  'path' | 'verb'
> &
  CreateCommentPathParams

/**
 * Creates a new comment for a shipment
 */
export const useCreateComment = ({ id, ...props }: UseCreateCommentProps) =>
  useMutate<CreateCommentResponse, unknown, void, CommentCreate, CreateCommentPathParams>(
    'POST',
    (paramsInPath: CreateCommentPathParams) => `/shipments/${paramsInPath.id}/comments`,
    { pathParams: { id }, ...props }
  )

export interface DeclineBidResponse {
  response?: string
}

export interface DeclineBidPathParams {
  id: number
}

export type DeclineBidProps = Omit<
  MutateProps<DeclineBidResponse, unknown, void, void, DeclineBidPathParams>,
  'path' | 'verb'
> &
  DeclineBidPathParams

/**
 * Declined a bid for the given shipment
 */
export const DeclineBid = ({ id, ...props }: DeclineBidProps) => (
  <Mutate<DeclineBidResponse, unknown, void, void, DeclineBidPathParams>
    verb='POST'
    path={`/shipments/${id}/decline`}
    {...props}
  />
)

export type UseDeclineBidProps = Omit<
  UseMutateProps<DeclineBidResponse, unknown, void, void, DeclineBidPathParams>,
  'path' | 'verb'
> &
  DeclineBidPathParams

/**
 * Declined a bid for the given shipment
 */
export const useDeclineBid = ({ id, ...props }: UseDeclineBidProps) =>
  useMutate<DeclineBidResponse, unknown, void, void, DeclineBidPathParams>(
    'POST',
    (paramsInPath: DeclineBidPathParams) => `/shipments/${paramsInPath.id}/decline`,
    { pathParams: { id }, ...props }
  )

export interface CreateShipmentDetentionResponse {
  success?: boolean
}

export interface CreateShipmentDetentionPathParams {
  id: number
}

export type CreateShipmentDetentionProps = Omit<
  MutateProps<
    CreateShipmentDetentionResponse,
    unknown,
    void,
    ShipmentDetentionRequest,
    CreateShipmentDetentionPathParams
  >,
  'path' | 'verb'
> &
  CreateShipmentDetentionPathParams

/**
 * Send detention request for a shipment
 */
export const CreateShipmentDetention = ({ id, ...props }: CreateShipmentDetentionProps) => (
  <Mutate<
    CreateShipmentDetentionResponse,
    unknown,
    void,
    ShipmentDetentionRequest,
    CreateShipmentDetentionPathParams
  >
    verb='POST'
    path={`/shipments/${id}/detention`}
    {...props}
  />
)

export type UseCreateShipmentDetentionProps = Omit<
  UseMutateProps<
    CreateShipmentDetentionResponse,
    unknown,
    void,
    ShipmentDetentionRequest,
    CreateShipmentDetentionPathParams
  >,
  'path' | 'verb'
> &
  CreateShipmentDetentionPathParams

/**
 * Send detention request for a shipment
 */
export const useCreateShipmentDetention = ({ id, ...props }: UseCreateShipmentDetentionProps) =>
  useMutate<
    CreateShipmentDetentionResponse,
    unknown,
    void,
    ShipmentDetentionRequest,
    CreateShipmentDetentionPathParams
  >(
    'POST',
    (paramsInPath: CreateShipmentDetentionPathParams) => `/shipments/${paramsInPath.id}/detention`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentDispatcherResponse {
  shipment?: Shipment
}

export interface UpdateShipmentDispatcherPathParams {
  id: number
}

export interface UpdateShipmentDispatcherRequestBody {
  shipment?: {
    dispatcher_id?: number | null
  }
}

export type UpdateShipmentDispatcherProps = Omit<
  MutateProps<
    UpdateShipmentDispatcherResponse,
    unknown,
    void,
    UpdateShipmentDispatcherRequestBody,
    UpdateShipmentDispatcherPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentDispatcherPathParams

/**
 * Updates a shipment's dispatcher
 */
export const UpdateShipmentDispatcher = ({ id, ...props }: UpdateShipmentDispatcherProps) => (
  <Mutate<
    UpdateShipmentDispatcherResponse,
    unknown,
    void,
    UpdateShipmentDispatcherRequestBody,
    UpdateShipmentDispatcherPathParams
  >
    verb='PUT'
    path={`/shipments/${id}/dispatcher`}
    {...props}
  />
)

export type UseUpdateShipmentDispatcherProps = Omit<
  UseMutateProps<
    UpdateShipmentDispatcherResponse,
    unknown,
    void,
    UpdateShipmentDispatcherRequestBody,
    UpdateShipmentDispatcherPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentDispatcherPathParams

/**
 * Updates a shipment's dispatcher
 */
export const useUpdateShipmentDispatcher = ({ id, ...props }: UseUpdateShipmentDispatcherProps) =>
  useMutate<
    UpdateShipmentDispatcherResponse,
    unknown,
    void,
    UpdateShipmentDispatcherRequestBody,
    UpdateShipmentDispatcherPathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipmentDispatcherPathParams) =>
      `/shipments/${paramsInPath.id}/dispatcher`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentDriversResponse {
  shipment?: Shipment
}

export interface UpdateShipmentDriversPathParams {
  id: number
}

export interface UpdateShipmentDriversRequestBody {
  shipment?: {
    driver_ids?: number[] | null
  }
}

export type UpdateShipmentDriversProps = Omit<
  MutateProps<
    UpdateShipmentDriversResponse,
    unknown,
    void,
    UpdateShipmentDriversRequestBody,
    UpdateShipmentDriversPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentDriversPathParams

/**
 * Updates a shipment's drivers
 *
 * Updates the list of drivers to provided list. An empty list will disassociate all drivers
 */
export const UpdateShipmentDrivers = ({ id, ...props }: UpdateShipmentDriversProps) => (
  <Mutate<
    UpdateShipmentDriversResponse,
    unknown,
    void,
    UpdateShipmentDriversRequestBody,
    UpdateShipmentDriversPathParams
  >
    verb='PUT'
    path={`/shipments/${id}/drivers`}
    {...props}
  />
)

export type UseUpdateShipmentDriversProps = Omit<
  UseMutateProps<
    UpdateShipmentDriversResponse,
    unknown,
    void,
    UpdateShipmentDriversRequestBody,
    UpdateShipmentDriversPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentDriversPathParams

/**
 * Updates a shipment's drivers
 *
 * Updates the list of drivers to provided list. An empty list will disassociate all drivers
 */
export const useUpdateShipmentDrivers = ({ id, ...props }: UseUpdateShipmentDriversProps) =>
  useMutate<
    UpdateShipmentDriversResponse,
    unknown,
    void,
    UpdateShipmentDriversRequestBody,
    UpdateShipmentDriversPathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipmentDriversPathParams) => `/shipments/${paramsInPath.id}/drivers`,
    { pathParams: { id }, ...props }
  )

export interface GetShipmentLocationsResponse {
  shipment?: ShipmentLocations
}

export interface GetShipmentLocationsPathParams {
  id: number
}

export type GetShipmentLocationsProps = Omit<
  GetProps<GetShipmentLocationsResponse, unknown, void, GetShipmentLocationsPathParams>,
  'path'
> &
  GetShipmentLocationsPathParams

/**
 * Retrieves a shipment's recent locations and ETA
 */
export const GetShipmentLocations = ({ id, ...props }: GetShipmentLocationsProps) => (
  <Get<GetShipmentLocationsResponse, unknown, void, GetShipmentLocationsPathParams>
    path={`/shipments/${id}/locations`}
    {...props}
  />
)

export type UseGetShipmentLocationsProps = Omit<
  UseGetProps<GetShipmentLocationsResponse, unknown, void, GetShipmentLocationsPathParams>,
  'path'
> &
  GetShipmentLocationsPathParams

/**
 * Retrieves a shipment's recent locations and ETA
 */
export const useGetShipmentLocations = ({ id, ...props }: UseGetShipmentLocationsProps) =>
  useGet<GetShipmentLocationsResponse, unknown, void, GetShipmentLocationsPathParams>(
    (paramsInPath: GetShipmentLocationsPathParams) => `/shipments/${paramsInPath.id}/locations`,
    { pathParams: { id }, ...props }
  )

export interface GetSharesResponse {
  shares?: Share[]
}

export interface GetSharesPathParams {
  id: number
}

export type GetSharesProps = Omit<
  GetProps<GetSharesResponse, unknown, void, GetSharesPathParams>,
  'path'
> &
  GetSharesPathParams

/**
 * Lists all shares for a shipment
 */
export const GetShares = ({ id, ...props }: GetSharesProps) => (
  <Get<GetSharesResponse, unknown, void, GetSharesPathParams>
    path={`/shipments/${id}/shares`}
    {...props}
  />
)

export type UseGetSharesProps = Omit<
  UseGetProps<GetSharesResponse, unknown, void, GetSharesPathParams>,
  'path'
> &
  GetSharesPathParams

/**
 * Lists all shares for a shipment
 */
export const useGetShares = ({ id, ...props }: UseGetSharesProps) =>
  useGet<GetSharesResponse, unknown, void, GetSharesPathParams>(
    (paramsInPath: GetSharesPathParams) => `/shipments/${paramsInPath.id}/shares`,
    { pathParams: { id }, ...props }
  )

export interface CreateShareResponse {
  share?: Share
}

export interface CreateSharePathParams {
  id: number
}

export type CreateShareProps = Omit<
  MutateProps<CreateShareResponse, unknown, void, Share, CreateSharePathParams>,
  'path' | 'verb'
> &
  CreateSharePathParams

/**
 * Creates a new share for a shipment
 */
export const CreateShare = ({ id, ...props }: CreateShareProps) => (
  <Mutate<CreateShareResponse, unknown, void, Share, CreateSharePathParams>
    verb='POST'
    path={`/shipments/${id}/shares`}
    {...props}
  />
)

export type UseCreateShareProps = Omit<
  UseMutateProps<CreateShareResponse, unknown, void, Share, CreateSharePathParams>,
  'path' | 'verb'
> &
  CreateSharePathParams

/**
 * Creates a new share for a shipment
 */
export const useCreateShare = ({ id, ...props }: UseCreateShareProps) =>
  useMutate<CreateShareResponse, unknown, void, Share, CreateSharePathParams>(
    'POST',
    (paramsInPath: CreateSharePathParams) => `/shipments/${paramsInPath.id}/shares`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentStatusResponse {
  shipment?: Shipment
}

export interface UpdateShipmentStatusPathParams {
  id: number
}

export interface UpdateShipmentStatusRequestBody {
  shipment?: {
    current_stop_sequence?: number | null
    status?: ShipmentStatus
  }
}

export type UpdateShipmentStatusProps = Omit<
  MutateProps<
    UpdateShipmentStatusResponse,
    unknown,
    void,
    UpdateShipmentStatusRequestBody,
    UpdateShipmentStatusPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentStatusPathParams

/**
 * Updates a shipment's status
 */
export const UpdateShipmentStatus = ({ id, ...props }: UpdateShipmentStatusProps) => (
  <Mutate<
    UpdateShipmentStatusResponse,
    unknown,
    void,
    UpdateShipmentStatusRequestBody,
    UpdateShipmentStatusPathParams
  >
    verb='PUT'
    path={`/shipments/${id}/status`}
    {...props}
  />
)

export type UseUpdateShipmentStatusProps = Omit<
  UseMutateProps<
    UpdateShipmentStatusResponse,
    unknown,
    void,
    UpdateShipmentStatusRequestBody,
    UpdateShipmentStatusPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentStatusPathParams

/**
 * Updates a shipment's status
 */
export const useUpdateShipmentStatus = ({ id, ...props }: UseUpdateShipmentStatusProps) =>
  useMutate<
    UpdateShipmentStatusResponse,
    unknown,
    void,
    UpdateShipmentStatusRequestBody,
    UpdateShipmentStatusPathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipmentStatusPathParams) => `/shipments/${paramsInPath.id}/status`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentSubscribersResponse {
  shipment?: Shipment
}

export interface UpdateShipmentSubscribersPathParams {
  id: number
}

export interface UpdateShipmentSubscribersRequestBody {
  shipment?: {
    notify_subscribers_about?: 'all_statuses' | 'active_statuses'
    subscribers?: {}[]
  }
}

export type UpdateShipmentSubscribersProps = Omit<
  MutateProps<
    UpdateShipmentSubscribersResponse,
    unknown,
    void,
    UpdateShipmentSubscribersRequestBody,
    UpdateShipmentSubscribersPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentSubscribersPathParams

/**
 * Updates a shipment's subscribers and subscription setting
 *
 * Updates the list of subscribers to provided list. An empty list will remove all subscribers. Existing contact IDs may be passed and the contact will be cloned as a subscriber. Also permits updating the shipment's subscription setting.
 */
export const UpdateShipmentSubscribers = ({ id, ...props }: UpdateShipmentSubscribersProps) => (
  <Mutate<
    UpdateShipmentSubscribersResponse,
    unknown,
    void,
    UpdateShipmentSubscribersRequestBody,
    UpdateShipmentSubscribersPathParams
  >
    verb='PUT'
    path={`/shipments/${id}/subscribers`}
    {...props}
  />
)

export type UseUpdateShipmentSubscribersProps = Omit<
  UseMutateProps<
    UpdateShipmentSubscribersResponse,
    unknown,
    void,
    UpdateShipmentSubscribersRequestBody,
    UpdateShipmentSubscribersPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentSubscribersPathParams

/**
 * Updates a shipment's subscribers and subscription setting
 *
 * Updates the list of subscribers to provided list. An empty list will remove all subscribers. Existing contact IDs may be passed and the contact will be cloned as a subscriber. Also permits updating the shipment's subscription setting.
 */
export const useUpdateShipmentSubscribers = ({ id, ...props }: UseUpdateShipmentSubscribersProps) =>
  useMutate<
    UpdateShipmentSubscribersResponse,
    unknown,
    void,
    UpdateShipmentSubscribersRequestBody,
    UpdateShipmentSubscribersPathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipmentSubscribersPathParams) =>
      `/shipments/${paramsInPath.id}/subscribers`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentTrackingMethodResponse {
  shipment?: Shipment
}

export interface UpdateShipmentTrackingMethodPathParams {
  id: number
}

export interface UpdateShipmentTrackingMethodRequestBody {
  driverPhone?: number | null
  trackingMethod?: string
}

export type UpdateShipmentTrackingMethodProps = Omit<
  MutateProps<
    UpdateShipmentTrackingMethodResponse,
    unknown,
    void,
    UpdateShipmentTrackingMethodRequestBody,
    UpdateShipmentTrackingMethodPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentTrackingMethodPathParams

/**
 * Updates a shipment's tracking method
 */
export const UpdateShipmentTrackingMethod = ({
  id,
  ...props
}: UpdateShipmentTrackingMethodProps) => (
  <Mutate<
    UpdateShipmentTrackingMethodResponse,
    unknown,
    void,
    UpdateShipmentTrackingMethodRequestBody,
    UpdateShipmentTrackingMethodPathParams
  >
    verb='PUT'
    path={`/shipments/${id}/tracking_method`}
    {...props}
  />
)

export type UseUpdateShipmentTrackingMethodProps = Omit<
  UseMutateProps<
    UpdateShipmentTrackingMethodResponse,
    unknown,
    void,
    UpdateShipmentTrackingMethodRequestBody,
    UpdateShipmentTrackingMethodPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentTrackingMethodPathParams

/**
 * Updates a shipment's tracking method
 */
export const useUpdateShipmentTrackingMethod = ({
  id,
  ...props
}: UseUpdateShipmentTrackingMethodProps) =>
  useMutate<
    UpdateShipmentTrackingMethodResponse,
    unknown,
    void,
    UpdateShipmentTrackingMethodRequestBody,
    UpdateShipmentTrackingMethodPathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipmentTrackingMethodPathParams) =>
      `/shipments/${paramsInPath.id}/tracking_method`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentTrailerResponse {
  shipment?: Shipment
}

export interface UpdateShipmentTrailerPathParams {
  id: number
}

export interface UpdateShipmentTrailerRequestBody {
  shipment?: {
    trailer_id?: number | null
  }
}

export type UpdateShipmentTrailerProps = Omit<
  MutateProps<
    UpdateShipmentTrailerResponse,
    unknown,
    void,
    UpdateShipmentTrailerRequestBody,
    UpdateShipmentTrailerPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentTrailerPathParams

/**
 * Updates a shipment's trailer
 */
export const UpdateShipmentTrailer = ({ id, ...props }: UpdateShipmentTrailerProps) => (
  <Mutate<
    UpdateShipmentTrailerResponse,
    unknown,
    void,
    UpdateShipmentTrailerRequestBody,
    UpdateShipmentTrailerPathParams
  >
    verb='PUT'
    path={`/shipments/${id}/trailer`}
    {...props}
  />
)

export type UseUpdateShipmentTrailerProps = Omit<
  UseMutateProps<
    UpdateShipmentTrailerResponse,
    unknown,
    void,
    UpdateShipmentTrailerRequestBody,
    UpdateShipmentTrailerPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentTrailerPathParams

/**
 * Updates a shipment's trailer
 */
export const useUpdateShipmentTrailer = ({ id, ...props }: UseUpdateShipmentTrailerProps) =>
  useMutate<
    UpdateShipmentTrailerResponse,
    unknown,
    void,
    UpdateShipmentTrailerRequestBody,
    UpdateShipmentTrailerPathParams
  >(
    'PUT',
    (paramsInPath: UpdateShipmentTrailerPathParams) => `/shipments/${paramsInPath.id}/trailer`,
    { pathParams: { id }, ...props }
  )

export interface UpdateShipmentTruckResponse {
  shipment?: Shipment
}

export interface UpdateShipmentTruckPathParams {
  id: number
}

export interface UpdateShipmentTruckRequestBody {
  shipment?: {
    truck_id?: number | null
  }
}

export type UpdateShipmentTruckProps = Omit<
  MutateProps<
    UpdateShipmentTruckResponse,
    unknown,
    void,
    UpdateShipmentTruckRequestBody,
    UpdateShipmentTruckPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentTruckPathParams

/**
 * Updates a shipment's truck
 */
export const UpdateShipmentTruck = ({ id, ...props }: UpdateShipmentTruckProps) => (
  <Mutate<
    UpdateShipmentTruckResponse,
    unknown,
    void,
    UpdateShipmentTruckRequestBody,
    UpdateShipmentTruckPathParams
  >
    verb='PUT'
    path={`/shipments/${id}/truck`}
    {...props}
  />
)

export type UseUpdateShipmentTruckProps = Omit<
  UseMutateProps<
    UpdateShipmentTruckResponse,
    unknown,
    void,
    UpdateShipmentTruckRequestBody,
    UpdateShipmentTruckPathParams
  >,
  'path' | 'verb'
> &
  UpdateShipmentTruckPathParams

/**
 * Updates a shipment's truck
 */
export const useUpdateShipmentTruck = ({ id, ...props }: UseUpdateShipmentTruckProps) =>
  useMutate<
    UpdateShipmentTruckResponse,
    unknown,
    void,
    UpdateShipmentTruckRequestBody,
    UpdateShipmentTruckPathParams
  >('PUT', (paramsInPath: UpdateShipmentTruckPathParams) => `/shipments/${paramsInPath.id}/truck`, {
    pathParams: { id },
    ...props,
  })

export interface ValidateTruckNumberResponse {
  valid?: boolean
}

export interface ValidateTruckNumberPathParams {
  id: number
}

export interface ValidateTruckNumberRequestBody {
  truckNumber?: string
}

export type ValidateTruckNumberProps = Omit<
  MutateProps<
    ValidateTruckNumberResponse,
    unknown,
    void,
    ValidateTruckNumberRequestBody,
    ValidateTruckNumberPathParams
  >,
  'path' | 'verb'
> &
  ValidateTruckNumberPathParams

/**
 * checks whether the truck number is valid
 */
export const ValidateTruckNumber = ({ id, ...props }: ValidateTruckNumberProps) => (
  <Mutate<
    ValidateTruckNumberResponse,
    unknown,
    void,
    ValidateTruckNumberRequestBody,
    ValidateTruckNumberPathParams
  >
    verb='POST'
    path={`/shipments/${id}/validate_truck_number`}
    {...props}
  />
)

export type UseValidateTruckNumberProps = Omit<
  UseMutateProps<
    ValidateTruckNumberResponse,
    unknown,
    void,
    ValidateTruckNumberRequestBody,
    ValidateTruckNumberPathParams
  >,
  'path' | 'verb'
> &
  ValidateTruckNumberPathParams

/**
 * checks whether the truck number is valid
 */
export const useValidateTruckNumber = ({ id, ...props }: UseValidateTruckNumberProps) =>
  useMutate<
    ValidateTruckNumberResponse,
    unknown,
    void,
    ValidateTruckNumberRequestBody,
    ValidateTruckNumberPathParams
  >(
    'POST',
    (paramsInPath: ValidateTruckNumberPathParams) =>
      `/shipments/${paramsInPath.id}/validate_truck_number`,
    { pathParams: { id }, ...props }
  )

export interface PostWaterfallReofferResponse {
  response?: string
}

export interface PostWaterfallReofferPathParams {
  id: number
}

export type PostWaterfallReofferProps = Omit<
  MutateProps<PostWaterfallReofferResponse, unknown, void, void, PostWaterfallReofferPathParams>,
  'path' | 'verb'
> &
  PostWaterfallReofferPathParams

/**
 * Re-offers this waterfall load to the user
 */
export const PostWaterfallReoffer = ({ id, ...props }: PostWaterfallReofferProps) => (
  <Mutate<PostWaterfallReofferResponse, unknown, void, void, PostWaterfallReofferPathParams>
    verb='POST'
    path={`/shipments/${id}/waterfall_reoffer`}
    {...props}
  />
)

export type UsePostWaterfallReofferProps = Omit<
  UseMutateProps<PostWaterfallReofferResponse, unknown, void, void, PostWaterfallReofferPathParams>,
  'path' | 'verb'
> &
  PostWaterfallReofferPathParams

/**
 * Re-offers this waterfall load to the user
 */
export const usePostWaterfallReoffer = ({ id, ...props }: UsePostWaterfallReofferProps) =>
  useMutate<PostWaterfallReofferResponse, unknown, void, void, PostWaterfallReofferPathParams>(
    'POST',
    (paramsInPath: PostWaterfallReofferPathParams) =>
      `/shipments/${paramsInPath.id}/waterfall_reoffer`,
    { pathParams: { id }, ...props }
  )

export interface DeleteCommentPathParams {
  shipment_id: number
}

export type DeleteCommentProps = Omit<
  MutateProps<void, unknown, void, number, DeleteCommentPathParams>,
  'path' | 'verb'
> &
  DeleteCommentPathParams

/**
 * Deletes an existing comment for a shipment
 */
export const DeleteComment = ({ shipment_id, ...props }: DeleteCommentProps) => (
  <Mutate<void, unknown, void, number, DeleteCommentPathParams>
    verb='DELETE'
    path={`/shipments/${shipment_id}/comments`}
    {...props}
  />
)

export type UseDeleteCommentProps = Omit<
  UseMutateProps<void, unknown, void, number, DeleteCommentPathParams>,
  'path' | 'verb'
> &
  DeleteCommentPathParams

/**
 * Deletes an existing comment for a shipment
 */
export const useDeleteComment = ({ shipment_id, ...props }: UseDeleteCommentProps) =>
  useMutate<void, unknown, void, number, DeleteCommentPathParams>(
    'DELETE',
    (paramsInPath: DeleteCommentPathParams) => `/shipments/${paramsInPath.shipment_id}/comments`,
    { pathParams: { shipment_id }, ...props }
  )

export interface UpdateCommentResponse {
  comment?: Comment
}

export interface UpdateCommentPathParams {
  shipment_id: number
  id: number
}

export type UpdateCommentProps = Omit<
  MutateProps<UpdateCommentResponse, unknown, void, CommentUpdate, UpdateCommentPathParams>,
  'path' | 'verb'
> &
  UpdateCommentPathParams

/**
 * Updates an existing comment for a shipment
 */
export const UpdateComment = ({ shipment_id, id, ...props }: UpdateCommentProps) => (
  <Mutate<UpdateCommentResponse, unknown, void, CommentUpdate, UpdateCommentPathParams>
    verb='PUT'
    path={`/shipments/${shipment_id}/comments/${id}`}
    {...props}
  />
)

export type UseUpdateCommentProps = Omit<
  UseMutateProps<UpdateCommentResponse, unknown, void, CommentUpdate, UpdateCommentPathParams>,
  'path' | 'verb'
> &
  UpdateCommentPathParams

/**
 * Updates an existing comment for a shipment
 */
export const useUpdateComment = ({ shipment_id, id, ...props }: UseUpdateCommentProps) =>
  useMutate<UpdateCommentResponse, unknown, void, CommentUpdate, UpdateCommentPathParams>(
    'PUT',
    (paramsInPath: UpdateCommentPathParams) =>
      `/shipments/${paramsInPath.shipment_id}/comments/${paramsInPath.id}`,
    { pathParams: { shipment_id, id }, ...props }
  )

export interface DeleteSharePathParams {
  shipment_id: number
}

export type DeleteShareProps = Omit<
  MutateProps<void, unknown, void, number, DeleteSharePathParams>,
  'path' | 'verb'
> &
  DeleteSharePathParams

/**
 * Expires an existing share for a shipment
 */
export const DeleteShare = ({ shipment_id, ...props }: DeleteShareProps) => (
  <Mutate<void, unknown, void, number, DeleteSharePathParams>
    verb='DELETE'
    path={`/shipments/${shipment_id}/shares`}
    {...props}
  />
)

export type UseDeleteShareProps = Omit<
  UseMutateProps<void, unknown, void, number, DeleteSharePathParams>,
  'path' | 'verb'
> &
  DeleteSharePathParams

/**
 * Expires an existing share for a shipment
 */
export const useDeleteShare = ({ shipment_id, ...props }: UseDeleteShareProps) =>
  useMutate<void, unknown, void, number, DeleteSharePathParams>(
    'DELETE',
    (paramsInPath: DeleteSharePathParams) => `/shipments/${paramsInPath.shipment_id}/shares`,
    { pathParams: { shipment_id }, ...props }
  )

export interface SendShareResponse {
  share?: Share
}

export interface SendSharePathParams {
  shipment_id: number
  id: number
}

export interface SendShareRequestBody {
  share_send?: ShareSend
}

export type SendShareProps = Omit<
  MutateProps<SendShareResponse, unknown, void, SendShareRequestBody, SendSharePathParams>,
  'path' | 'verb'
> &
  SendSharePathParams

/**
 * Sends a share to the recipient
 */
export const SendShare = ({ shipment_id, id, ...props }: SendShareProps) => (
  <Mutate<SendShareResponse, unknown, void, SendShareRequestBody, SendSharePathParams>
    verb='POST'
    path={`/shipments/${shipment_id}/shares/${id}/send`}
    {...props}
  />
)

export type UseSendShareProps = Omit<
  UseMutateProps<SendShareResponse, unknown, void, SendShareRequestBody, SendSharePathParams>,
  'path' | 'verb'
> &
  SendSharePathParams

/**
 * Sends a share to the recipient
 */
export const useSendShare = ({ shipment_id, id, ...props }: UseSendShareProps) =>
  useMutate<SendShareResponse, unknown, void, SendShareRequestBody, SendSharePathParams>(
    'POST',
    (paramsInPath: SendSharePathParams) =>
      `/shipments/${paramsInPath.shipment_id}/shares/${paramsInPath.id}/send`,
    { pathParams: { shipment_id, id }, ...props }
  )

export interface DeleteShipmentStopResponse {
  comment?: Shipment
}

export interface DeleteShipmentStopPathParams {
  shipment_id: number
}

export type DeleteShipmentStopProps = Omit<
  MutateProps<DeleteShipmentStopResponse, unknown, void, number, DeleteShipmentStopPathParams>,
  'path' | 'verb'
> &
  DeleteShipmentStopPathParams

/**
 * Deletes an existing stop for a shipment
 */
export const DeleteShipmentStop = ({ shipment_id, ...props }: DeleteShipmentStopProps) => (
  <Mutate<DeleteShipmentStopResponse, unknown, void, number, DeleteShipmentStopPathParams>
    verb='DELETE'
    path={`/shipments/${shipment_id}/stops`}
    {...props}
  />
)

export type UseDeleteShipmentStopProps = Omit<
  UseMutateProps<DeleteShipmentStopResponse, unknown, void, number, DeleteShipmentStopPathParams>,
  'path' | 'verb'
> &
  DeleteShipmentStopPathParams

/**
 * Deletes an existing stop for a shipment
 */
export const useDeleteShipmentStop = ({ shipment_id, ...props }: UseDeleteShipmentStopProps) =>
  useMutate<DeleteShipmentStopResponse, unknown, void, number, DeleteShipmentStopPathParams>(
    'DELETE',
    (paramsInPath: DeleteShipmentStopPathParams) => `/shipments/${paramsInPath.shipment_id}/stops`,
    { pathParams: { shipment_id }, ...props }
  )

export interface GetSubsribableContactsResponse {
  contacts?: Contact[]
}

export interface GetSubsribableContactsQueryParams {
  /**
   * How to filter the results
   */
  filters?: ContactFilters
  /**
   * Which page of results to return
   */
  page_number?: number
  /**
   * How many results to return per page
   */
  page_size?: number
  /**
   * Field to use for sorting results
   */
  sort_field?: string
  /**
   * Direction to sort results
   */
  sort_order?: string
}

export type GetSubsribableContactsProps = Omit<
  GetProps<GetSubsribableContactsResponse, unknown, GetSubsribableContactsQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of contacts that may be added to a shipment as a subscriber
 *
 * Contacts returned by this API are de-duplicated by name and email, with only the most recent duplicate contact returned.
 */
export const GetSubsribableContacts = (props: GetSubsribableContactsProps) => (
  <Get<GetSubsribableContactsResponse, unknown, GetSubsribableContactsQueryParams, void>
    path={`/subscribable_contacts`}
    {...props}
  />
)

export type UseGetSubsribableContactsProps = Omit<
  UseGetProps<GetSubsribableContactsResponse, unknown, GetSubsribableContactsQueryParams, void>,
  'path'
>

/**
 * Retrieves a list of contacts that may be added to a shipment as a subscriber
 *
 * Contacts returned by this API are de-duplicated by name and email, with only the most recent duplicate contact returned.
 */
export const useGetSubsribableContacts = (props: UseGetSubsribableContactsProps) =>
  useGet<GetSubsribableContactsResponse, unknown, GetSubsribableContactsQueryParams, void>(
    `/subscribable_contacts`,
    props
  )

export interface GetTodosResponse {
  counts?: {
    missing_driver?: number
    missing_truck_number?: number
    missing_vin?: number
    pod_missing?: number
    pod_rejected?: number
  }
  todos?: Todo[]
}

export type GetTodosProps = Omit<GetProps<GetTodosResponse, unknown, void, void>, 'path'>

/**
 * Retrieves lists of todos (for Transfix shipments)
 */
export const GetTodos = (props: GetTodosProps) => (
  <Get<GetTodosResponse, unknown, void, void> path={`/todos`} {...props} />
)

export type UseGetTodosProps = Omit<UseGetProps<GetTodosResponse, unknown, void, void>, 'path'>

/**
 * Retrieves lists of todos (for Transfix shipments)
 */
export const useGetTodos = (props: UseGetTodosProps) =>
  useGet<GetTodosResponse, unknown, void, void>(`/todos`, props)

export interface CreateTrailerResponse {
  trailer?: Trailer
}

export type CreateTrailerProps = Omit<
  MutateProps<CreateTrailerResponse, unknown, void, Trailer, void>,
  'path' | 'verb'
>

/**
 * Creates a new trailer
 */
export const CreateTrailer = (props: CreateTrailerProps) => (
  <Mutate<CreateTrailerResponse, unknown, void, Trailer, void>
    verb='POST'
    path={`/trailers`}
    {...props}
  />
)

export type UseCreateTrailerProps = Omit<
  UseMutateProps<CreateTrailerResponse, unknown, void, Trailer, void>,
  'path' | 'verb'
>

/**
 * Creates a new trailer
 */
export const useCreateTrailer = (props: UseCreateTrailerProps) =>
  useMutate<CreateTrailerResponse, unknown, void, Trailer, void>('POST', `/trailers`, props)

export interface CreateTruckResponse {
  truck?: Truck
}

export type CreateTruckProps = Omit<
  MutateProps<CreateTruckResponse, unknown, void, Truck, void>,
  'path' | 'verb'
>

/**
 * Creates a new truck
 */
export const CreateTruck = (props: CreateTruckProps) => (
  <Mutate<CreateTruckResponse, unknown, void, Truck, void>
    verb='POST'
    path={`/trucks`}
    {...props}
  />
)

export type UseCreateTruckProps = Omit<
  UseMutateProps<CreateTruckResponse, unknown, void, Truck, void>,
  'path' | 'verb'
>

/**
 * Creates a new truck
 */
export const useCreateTruck = (props: UseCreateTruckProps) =>
  useMutate<CreateTruckResponse, unknown, void, Truck, void>('POST', `/trucks`, props)

export interface KeepTruckinImportedTruckLocationsResponse {
  truckLocations?: KeepTruckinTruckLocations[]
}

export type KeepTruckinImportedTruckLocationsProps = Omit<
  GetProps<KeepTruckinImportedTruckLocationsResponse, unknown, void, void>,
  'path'
>

/**
 * retreives truck locations from keep truckin
 */
export const KeepTruckinImportedTruckLocations = (
  props: KeepTruckinImportedTruckLocationsProps
) => (
  <Get<KeepTruckinImportedTruckLocationsResponse, unknown, void, void>
    path={`/trucks/imported_locations`}
    {...props}
  />
)

export type UseKeepTruckinImportedTruckLocationsProps = Omit<
  UseGetProps<KeepTruckinImportedTruckLocationsResponse, unknown, void, void>,
  'path'
>

/**
 * retreives truck locations from keep truckin
 */
export const useKeepTruckinImportedTruckLocations = (
  props: UseKeepTruckinImportedTruckLocationsProps
) =>
  useGet<KeepTruckinImportedTruckLocationsResponse, unknown, void, void>(
    `/trucks/imported_locations`,
    props
  )

export interface KeepTruckinTruckLocationsResponse {
  truckLocations?: KeepTruckinTruckLocations[]
}

export type KeepTruckinTruckLocationsProps = Omit<
  GetProps<KeepTruckinTruckLocationsResponse, unknown, void, void>,
  'path'
>

/**
 * retreives truck locations from keep truckin
 */
export const KeepTruckinTruckLocations = (props: KeepTruckinTruckLocationsProps) => (
  <Get<KeepTruckinTruckLocationsResponse, unknown, void, void>
    path={`/trucks/locations`}
    {...props}
  />
)

export type UseKeepTruckinTruckLocationsProps = Omit<
  UseGetProps<KeepTruckinTruckLocationsResponse, unknown, void, void>,
  'path'
>

/**
 * retreives truck locations from keep truckin
 */
export const useKeepTruckinTruckLocations = (props: UseKeepTruckinTruckLocationsProps) =>
  useGet<KeepTruckinTruckLocationsResponse, unknown, void, void>(`/trucks/locations`, props)
